import React, { useState, useEffect, useCallback, memo } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth } from "../Auth";
import  {             
            Button,
            Checkbox,
            Chip,
            Dialog,
            DialogActions,
            DialogContent,
            Fab,
            FormControlLabel,
            Grid,
            Grow,
            IconButton,
            Input,
            LinearProgress,
            Menu,
            MenuItem,
            Paper,
            Slider,
            Switch,          
            TableBody,
            TableHead,
            TablePagination,
            TableSortLabel,
            TableRow,
            TextField,
            Tooltip,
            withWidth,
} from '@material-ui/core';
import { 
            Add as AddIcon,
            Autorenew as AutorenewIcon,
            BorderVertical as BorderVerticalIcon,
            Brush as BrushIcon,
            Cancel as CancelIcon,
            Check as CheckIcon,
            CheckBox as CheckBoxIcon,
            CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
            ChevronLeft as ChevronLeftIcon,
            ChevronRight as ChevronRightIcon,
            Clear as ClearIcon,
            DateRange as DateRangeIcon,
            Delete as DeleteIcon,
            Description as DescriptionIcon,
            Edit as EditIcon,
            FilterList as FilterListIcon,
            FilterNone as FilterNoneIcon,
            MarkunreadMailbox as MarkunreadMailboxIcon,
            MoreVert as MoreVertIcon,
            NavigateNext as NavigateNextIcon,
            PictureAsPdf as PictureAsPdfIcon,
            PlusOne as PlusOneIcon,
            Router as RouterIcon,
            Save as SaveIcon,
            Search as SearchIcon,
            Visibility as VisibilityIcon,
            ViewWeek as ViewWeekIcon,
} from '@material-ui/icons';
//import socketIOClient from "socket.io-client";
import FacebookCircularProgress from './FacebookCircularProgress';
import styled from 'styled-components';
import { Autocomplete } from '@material-ui/lab';
import { 
    Button as ButtonAntd,
    Modal as ModalAntd,
    Popconfirm,
    Switch as SwitchAntd ,
    Tooltip as TooltipAntd,
} from 'antd';
import Swal from 'sweetalert2';
import PdfElement from './PdfElement';
import { 
    AppstoreAddOutlined as AppstoreAddOutlinedIcon,
    CopyOutlined as ContentCopyIcon, 
    // DollarOutlined as DollarOutlinedIcon,
    LoadingOutlined as LoadingOutlinedIcon
} from '@ant-design/icons';
import {
    TableContainerYounet,
    TableYounet,
    TheadYounetStyledFixed,
    TheadYounetStyled,
} from './TablaContainerYounet';
import ExcelComponent from '../Elementos/ExcelComponent';
import { v4 as uuidv4 } from 'uuid';


    const moment = require('moment-timezone'); 

    const useStyles = makeStyles((theme) => ({
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2),
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1,
            color:'#fff'
        },
    }));

    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Grow direction="up" ref={ref} {...props} timeout={750} />;
    });

    const TdYounetStyledFixed = styled.td`
        color:${props => props.color ? props.color : 'black'};
        font-size:${props => props.fontSize ?  props.fontSize : '10px'};
        font-weight:${props => props.bolder ? 'bold' : 'none'};
        min-width:${props => props.width || 60};
        width:${props => props.width || 60};
        padding-top:${props => props.element ? '0px' : '5px'}; 
        text-align:${props => props.align ? props.align : 'left'};
        background:#ffffff;
        border-bottom: 1px solid #E5E8E8;
        display:block;
        height:${props => props.isMultiline ? 'auto' : '43px'};
        max-height:${props => props.isMultiline ? 'auto' : '43px'};
        padding:6px; 
        position:sticky;
        z-index:1; 
        left:${props => props.left || '0px'};
        text-overflow: ellipsis; 
        white-space:${props => props.isMultiline ? 'pre-wrap' : 'nowrap'} ;  
        overflow:${props => props.isMultiline ? 'auto' : 'hidden'};
    `;

    const TdYounetStyled = styled.td`
        color:${props => props.color ? props.color : 'black'};
        font-size:${props => props.fontSize ?  props.fontSize : '10px'};
        font-weight:${props => props.bolder ? 'bold' : 'none'};
        min-width:${props => props.width || 60};
        width:${props => props.width || 60};
        padding-top:${props => props.paddingTop ? props.paddingTop : '5px'}; 
        text-align:${props => props.align ? props.align : 'left'};
        background:transparent;
        border-bottom: 1px solid #E5E8E8;
        display:block;
        height:${props => props.isMultiline ? 'auto' : '43px'};
        max-height:${props => props.isMultiline ? 'auto' : '43px'};
        padding:${props => props.padding ? props.padding : '10px'};   
        position:relative;
        left:0px;      
        text-overflow: ellipsis;    
        white-space:${props => props.isMultiline ? 'pre-wrap' : 'nowrap'} ;  
        overflow:${props => props.isMultiline ? 'auto' : 'hidden'};
    `;

    const TrYounetStyled = styled.tr`
        display:flex;
        position:'sticky';
        top:0px;
        z-index:2;
        background-color:${props => props.selected ? 'LightBlue' : '#fff'};
        &:hover{
            background-color:Gainsboro
        }
    `;

    const TdYounetStyledFixed2 = styled.td`
        color:${props => props.color ? props.color : 'black'};
        font-size:${props => props.fontSize ?  props.fontSize : '12px'};
        font-weight:${props => props.bolder ? 'bold' : 'none'};
        minWidth:${props => props.minWidth || 60};
        text-align:${props => props.align ? props.align : 'left'};
        width:${props => props.width || 60};
        background:#ffffff;
        border-bottom: 1px solid #E5E8E8;
        display:block;
        height:${props => props.isMultiline ? 'auto' : '43px'};
        max-height:${props => props.isMultiline ? 'auto' : '43px'};
        padding:${props => props.padding ? props.padding : '6px 10px 4px 10px'};  
        position:sticky;
        z-index:1; 
        left:${props => props.left || '0px'};
        text-overflow: ellipsis; 
        white-space:${props => props.isMultiline ? 'pre-wrap' : 'nowrap'} ;  
        overflow:${props => props.isMultiline ? 'auto' : 'hidden'};
    `;

    const TdYounetStyled2 = styled.td`
        color:${props => props.color ? props.color : 'black'};
        font-size:${props => props.fontSize ?  props.fontSize : '12px'};
        font-weight:${props => props.bolder ? 'bold' : 'none'};
        minWidth:${props => props.minWidth || 60};
        text-align:${props => props.align ? props.align : 'left'};
        width:${props => props.width || 60};
        background:transparent;
        border-bottom: 1px solid #E5E8E8;
        display:block;
        height:${props => props.isMultiline ? 'auto' : '43px'};
        max-height:${props => props.isMultiline ? 'auto' : '43px'};
        padding:${props => props.padding ? props.padding : '6px 10px 4px 10px'}; 
        position:relative;
        left:0px;      
        text-overflow: ellipsis;    
        white-space:${props => props.isMultiline ? 'pre-wrap' : 'nowrap'} ;  
        overflow:${props => props.isMultiline ? 'auto' : 'hidden'};
    `;

    const propsWidth = { general:100 };

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
          return -1;
        }
        if (b[orderBy] > a[orderBy]) {
          return 1;
        }
        return 0;
    };
      
    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };
      
    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    };

    const TheadYounetFixed = memo(({widthDefault, createSortHandler, order, orderBy, headCell, classes, headCells, align})=>{
        const [ leftValue, setLeftValue ] = useState('0px')
        
        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
            }else{
                let numero = 0;
                for(let i=0; i<headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
                setLeftValue(`${numero}px`)
            }
            
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        return(
            <TheadYounetStyledFixed width={widthDefault} left={leftValue} align={align}>
                <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)} 
                    style={{color:'#fff', textAlign:align}}
                >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                    ) : null}
                </TableSortLabel>
            </TheadYounetStyledFixed>
        );
    });

    const TheadYounet = memo(({widthDefault, createSortHandler, order, orderBy, headCell, classes, align})=>( 
        <TheadYounetStyled width={widthDefault} align={align}>
            <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)} 
                style={{color:'#fff', textAlign:align}}
            >
                {headCell.label}
                {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
                ) : null}
            </TableSortLabel>
        </TheadYounetStyled>
    ));

    const TdYounet = memo(((props)=>{
        const { 
            minWidth, 
            width, 
            headCells, 
            headCell, 
            valueInfo, 
            fixed, 
            color, 
            align, 
            bolder, 
            fontSize, 
            variablesObject,            
        } = props
        const [ leftValue, setLeftValue ] = useState('0px');

        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
            }else{
                let numero = 0;
                for(let i=0; i < headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
               
                setLeftValue(`${numero}px`)
            }
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        
        return(
            <React.Fragment>
            {
                fixed ?
                <TdYounetStyledFixed 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                    isMultiline={variablesObject.isMultiline}
                >
                    {valueInfo}
                </TdYounetStyledFixed>
                :
                <TdYounetStyled 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                    isMultiline={variablesObject.isMultiline}
                >
                    {valueInfo}
                </TdYounetStyled>
            }
            </React.Fragment>
        )
        
        
    }));

    const TdYounetEdit = memo(((props)=>{
        const { valueInfo, minWidth, width, headCells, headCell, fixed, color, align, bolder, fontSize, idEl, handleRowNew, variablesObject, marcas, tipos} = props
        const [ leftValue, setLeftValue ] = useState('0px');
        const [ infoCell, setInfoCell ] = useState('');

        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
                setInfoCell(valueInfo);
            }else{
                let numero = 0;
                for(let i=0; i<headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
                setInfoCell(valueInfo);
                setLeftValue(`${numero}px`)
            }
            console.log(headCell)
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        const handleEditCell = ({target})=>{
            if(variablesObject.isUpperCase){
                if(variablesObject.inputTrim){
                    setInfoCell(target.value.toString().toUpperCase().trim());
                }else{
                    setInfoCell(target.value.toString().toUpperCase());
                }
            }else{
                if(variablesObject.inputTrim){
                    setInfoCell(target.value.toString().trim());
                }else{
                    setInfoCell(target.value.toString());
                }
            }
            
        };

        const handleSelectCell = ({target})=>{ 
            setInfoCell(target.value)
            handleRowNew(idEl, target.value);
        }

        const handleSendInfo = ()=>{
            handleRowNew(idEl, infoCell);
        };

        return(
            <React.Fragment>
            {
                fixed ?
                <TdYounetStyledFixed2
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                    isMultiline={variablesObject.isMultiline}
                >
                    {                                       
                        headCell.type === 'select1' && headCell.id === 'Marca'
                        ?                       
                            <TextField
                                id={uuidv4()}
                                select
                                variant="standard"
                                size='small'
                                fullWidth
                                onChange={handleSelectCell}
                                value={infoCell || ''}
                                >
                                {marcas.map((option) => (
                                    <MenuItem key={uuidv4()} value={option.Marca}>
                                    {option.Marca}
                                    </MenuItem>
                                ))}
                            </TextField>

                        : headCell.type === 'select1' && headCell.id === 'Tipo'
                        ?
                            <TextField
                                id={uuidv4()}
                                select
                                variant="standard"
                                size='small'
                                fullWidth
                                onChange={handleSelectCell}
                                value={infoCell || ''}
                                >
                                {tipos.map((option) => (
                                    <MenuItem key={uuidv4()} value={option.Tipo}>
                                    {option.Tipo}
                                    </MenuItem>
                                ))}
                            </TextField>
                        :
                            <Input
                                id={idEl}
                                value={infoCell || ''}
                                style={{marginTop:-1}}
                                variant='outlined'
                                onChange={handleEditCell}
                                onBlur={handleSendInfo}
                                fullWidth
                                // margin='dense'
                                disableUnderline={variablesObject.isMultiline}
                                multiline={variablesObject.isMultiline}
                            />
                    }
                </TdYounetStyledFixed2>
                :
                <TdYounetStyled2
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                    isMultiline={variablesObject.isMultiline}
                >
                    {
                        headCell.type === 'select1' && headCell.id === 'Marca'
                        ?
                            <TextField
                                id={uuidv4()}
                                select
                                variant="standard"
                                size='small'
                                fullWidth
                                onChange={handleSelectCell}
                                value={infoCell || ''}
                                >
                                {marcas.map((option) => (
                                    <MenuItem key={uuidv4()} value={option.Marca}>
                                    {option.Marca}
                                    </MenuItem>
                                ))}
                            </TextField>
                        : headCell.type === 'select1' && headCell.id === 'Tipo'
                        ?
                            <TextField
                                id={uuidv4()}
                                select
                                variant="standard"
                                size='small'
                                fullWidth
                                onChange={handleSelectCell}
                                value={infoCell || ''}
                                >
                                {tipos.map((option) => (
                                    <MenuItem key={uuidv4()} value={option.Tipo}>
                                    {option.Tipo}
                                    </MenuItem>
                                ))}
                            </TextField>
                        : 
                            <Input
                                id={idEl}
                                style={{marginTop:-1}}
                                value={infoCell || ''}
                                variant='outlined'
                                onChange={handleEditCell}
                                onBlur={handleSendInfo}
                                fullWidth
                                // margin='dense'
                                disableUnderline={variablesObject.isMultiline}
                                multiline={variablesObject.isMultiline}
                            />
                        }
                </TdYounetStyled2>
            }
            </React.Fragment>
        )
        
        
    }));

    const TdYounetEditMac = memo(((props)=>{
        const { getArrMac, valorOriginal, isModeEdit, valueInfo, minWidth, width, headCells, headCell, fixed, color, align, bolder, fontSize, idEl, handleRowNew } = props
        const [ leftValue, setLeftValue ] = useState('0px');
        const [ infoCell, setInfoCell ] = useState('');
        

        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
                setInfoCell(valueInfo);
            }else{
                let numero = 0;
                for(let i=0; i<headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
                setInfoCell(valueInfo);
                setLeftValue(`${numero}px`)
            }
        },[]); // eslint-disable-line react-hooks/exhaustive-deps


        const handleSendInfo = ({target})=>{ 
            var val = target.value.toUpperCase().replace(/[^\d|A-Z]/g, '').match(/.{1,2}/g || []);
            if(isModeEdit){
                if(valorOriginal === (val !== null ? val.join(":") : val)){
                    handleRowNew(idEl, val !== null ? val.join(":") : val) ;
                }else{
                    if( getArrMac.includes(val !== null ? val.join(":") : val)){
                        alert('YA EXISTE UNA MAC IGUAL')
                    }else{
                        handleRowNew(idEl, val !== null ? val.join(":") : val) ;
                    }
                }
            }else{
                if( getArrMac.includes(val !== null ? val.join(":") : val)){
                    alert('YA EXISTE UNA MAC IGUAL')
                }else{
                    handleRowNew(idEl, val !== null ? val.join(":") : val) ;
                }
            }
        };

        const handleEditCell = ({target})=>{
            var val = target.value.toUpperCase().replace(/[^\d|A-Z]/g, '').match(/.{1,2}/g || []);
            setInfoCell(val !== null ? val.join(":") : val )
        };

        return(
            <React.Fragment>
            {
                fixed ?
                <TdYounetStyledFixed2
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                > 
                    <Input
                        id={idEl}
                        value={infoCell || ''}
                        style={{marginTop:16}}
                        onChange={handleEditCell}
                        onBlur={handleSendInfo}
                        fullWidth
                        margin='dense'
                    />  
                </TdYounetStyledFixed2>
                :
                <TdYounetStyled2
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    <Input
                        id={idEl}
                        value={infoCell || ''}
                        style={{marginTop:16}}
                        onChange={handleEditCell}
                        onBlur={handleSendInfo}
                        fullWidth
                        margin='dense'
                    />
                </TdYounetStyled2>
            }
            </React.Fragment>
        )
        
        
    }));

    const TdYounetEditFecha = memo(((props)=>{
        const {valueInfo, minWidth, width, headCells, headCell, fixed, color, align, bolder, fontSize, idEl, handleRowNew } = props
        const [ leftValue, setLeftValue ] = useState('0px');
        const [ infoCell, setInfoCell ] = useState('');
        

        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
                setInfoCell(valueInfo);
            }else{
                let numero = 0;
                for(let i=0; i<headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
                setInfoCell(valueInfo);
                setLeftValue(`${numero}px`)
            }
        },[]); // eslint-disable-line react-hooks/exhaustive-deps


        const handleSendInfo = ({target})=>{ 
            handleRowNew(idEl, target.value) ;
        };

        const handleEditCell = ({target})=>{
            setInfoCell(target.value)
        };

        return(
            <React.Fragment>
            {
                fixed ?
                <TdYounetStyledFixed2
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                > 
                    <Input
                        id={idEl}
                        value={infoCell || ''}
                        style={{marginTop:0}}
                        onChange={handleEditCell}
                        onBlur={handleSendInfo}
                        fullWidth
                        margin='dense'
                        type='date'
                    />  
                </TdYounetStyledFixed2>
                :
                <TdYounetStyled2
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    <Input
                        id={idEl}
                        value={infoCell || ''}
                        style={{marginTop:0}}
                        onChange={handleEditCell}
                        onBlur={handleSendInfo}
                        fullWidth
                        margin='dense'
                        type='date'
                    />
                </TdYounetStyled2>
            }
            </React.Fragment>
        )
        
        
    }));

    const TdYounetEditSwitch = memo(((props)=>{
        const { valueInfo, minWidth, width, headCells, headCell, fixed, color, align, bolder, fontSize, idEl, handleRowNew } = props
        const [ leftValue, setLeftValue ] = useState('0px');
        const [ infoCell, setInfoCell ] = useState(false);
        

        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
                setInfoCell(valueInfo);
            }else{
                let numero = 0;
                for(let i=0; i<headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
                setInfoCell(valueInfo);
                setLeftValue(`${numero}px`)
            }
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        const handleEditCell = (checked)=>{ 
            setInfoCell(checked); 
            handleRowNew(idEl, checked)
        };


        return(
            <React.Fragment>
            {
                fixed ?
                <TdYounetStyledFixed2
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                    style={{display:'flex', justifyContent:'center', alignItems:'center'}}
                > 
                    <SwitchAntd checkedChildren="SI" unCheckedChildren="NO" checked={infoCell} onChange={handleEditCell} /> 
                </TdYounetStyledFixed2>
                :
                <TdYounetStyled2
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                    style={{display:'flex', justifyContent:'center', alignItems:'center'}}
                >
                    <SwitchAntd checkedChildren="SI" unCheckedChildren="NO" checked={infoCell} onChange={handleEditCell} />
                </TdYounetStyled2>
            }
            </React.Fragment>
        )
        
        
    }));

    const TdYounetEditSelect = memo(((props)=>{
        const { valueInfo, minWidth, width, headCells, headCell, fixed, color, align, bolder, fontSize, idEl, handleRowNew, arrInfoSelect  } = props
        const [ leftValue, setLeftValue ] = useState('0px');
        const [ infoCell, setInfoCell ] = useState('');
        

        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
                setInfoCell(valueInfo);
            }else{
                let numero = 0;
                for(let i=0; i<headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
                setInfoCell(valueInfo);
                setLeftValue(`${numero}px`)
            }
        },[]); // eslint-disable-line react-hooks/exhaustive-deps


        const handleSelectInfo = (e, value)=>{
            setInfoCell(value);
            handleRowNew(idEl, value);
        };

        return(
            <React.Fragment>
            {
                fixed ?
                <TdYounetStyledFixed2
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                > 
                    <Autocomplete
                        id={idEl}
                        options={arrInfoSelect[idEl]}
                        value={infoCell || ''}                              
                        renderInput={(params) => <TextField {...params} variant="standard" size='small' fullWidth color='primary'/>}
                        onChange={handleSelectInfo} 
                        size='small'
                        style={{marginTop:-1.5}}
                    />
                </TdYounetStyledFixed2>
                :
                <TdYounetStyled2
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    <Autocomplete
                        id={idEl}
                        options={arrInfoSelect[idEl]}
                        value={infoCell || ''}                              
                        renderInput={(params) => <TextField {...params}  variant="standard" size='small' fullWidth color='primary'/>}
                        onChange={handleSelectInfo}  
                        size='small'
                        style={{marginTop:-1.5}}
                    />
                </TdYounetStyled2>
            }
            </React.Fragment>
        )
        
        
    }));

    function EnhancedTableHead(props) {
        
        const { classes, order, orderBy, onRequestSort, headCells, HandleChangeWidth, variablesObject } = props;

        const createSortHandler = (property) => (event) => {
          onRequestSort(event, property);
        };
    
        return (
            <TableHead style={{position:'sticky', top:0, zIndex:10}}>
                <TableRow style={{display:'flex'}} >
                    <TheadYounetStyled minWidth={variablesObject.widthAction} width={variablesObject.widthAction} align='left'>
                        ACTIONS
                    </TheadYounetStyled>
                {headCells.map( headCell =>  
                    headCell.show && ( 
                        headCell.fixed 
                        ? 
                        <TheadYounetFixed  
                            headCells={headCells} 
                            HandleChangeWidth={HandleChangeWidth} 
                            key={headCell.id} 
                            widthDefault={headCell.width} 
                            createSortHandler={createSortHandler} 
                            order={order} 
                            orderBy={orderBy} 
                            headCell={headCell} 
                            classes={classes} 
                            align={headCell.align}
                            variablesObject={variablesObject}
                            />
                        : 
                        <TheadYounet  
                            headCells={headCells} 
                            HandleChangeWidth={HandleChangeWidth}
                            key={headCell.id} 
                            widthDefault={headCell.width} 
                            createSortHandler={createSortHandler} 
                            order={order} 
                            orderBy={orderBy} 
                            headCell={headCell} 
                            classes={classes} 
                            align={headCell.align}
                            variablesObject={variablesObject}
                         />
                        
                ))}
                </TableRow>
            </TableHead>
        );
    };
    
    const FiltradoEl = ({ index, info, HandleAddFilter, HandleDeleteFilter, HandleAddInformacionFilter, headersColumn})=>{
        const [ elementValue, setElementValue ] = useState({ idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'O', type:''});

        useEffect(()=>{
            setElementValue({ idElement:info.idElement, valorElement:info.valorElement, numero:index, labelElement:info.labelElement, selectElement:info.selectElement, type:info.type})
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        const HandleElementValue = (e)=>{
            setElementValue({...elementValue, valorElement:e.target.value});
           // HandleAddInformacionFilter(index, e.target.id, e.target.value)
        };

        const HandlePreDeleteFilter = ()=>{
            HandleDeleteFilter(index);
        };

        const HandlePreAddInfFilter = (e)=>{
            HandleAddInformacionFilter(elementValue)
        };

        const HandleAutoComplete = (e, value)=>{
            if(value === '' || value === null){
                setElementValue({...elementValue, idElement:'', labelElement:'', valorElement:''});
            }else{ 
                const arrFilHeaders = headersColumn.filter(value2=> value2.label === value);
                if(arrFilHeaders.length > 0){
                    setElementValue({...elementValue, idElement:arrFilHeaders[0].id.toString(), labelElement:value, type:arrFilHeaders[0].type.toString()});
                }
                
            }
            
        };

        const HandleSelectElement = (e)=>{
            setElementValue({...elementValue, selectElement:e.target.value});
        };

        const handleDatosMac = ({target})=>{
            var val = target.value.toUpperCase().replace(/[^\d|A-Z]/g, '').match(/.{1,2}/g || []);
            setElementValue({...elementValue, valorElement:val !== null ? val.join(":") : val});
        };

        if(index === 0){
            return( 
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}  key={`ElementMenu-Filtrado-${index}`}>
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5} style={{paddingTop:12}}>
                            <Autocomplete
                                id={`idElement-${index}`}
                                options={headersColumn}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                inputValue={elementValue.labelElement || ''}
                                
                                onInputChange={HandleAutoComplete}
                                size='small'
                            />
                        </Grid>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                elementValue.type === 'number' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='number'
                                />: elementValue.type === 'date' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='date'
                                />: elementValue.type === 'mac' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={handleDatosMac}
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}     
                                />: 
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                />
                            }
                        </Grid>
                        <Grid item xl={1} lg={2} md={2} sm={2} xs={2}>
                            <IconButton style={{marginTop:5}} onClick={HandleAddFilter}>
                                <AddIcon color='primary'/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            )
        }else{ 
            return(
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} key={`ElementMenu-Filtrado-${index}`}>
                    <Grid container justifyContent='center' spacing={1} >
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5} style={{paddingTop:12}}>
                            <Autocomplete
                                id={`idElement-${index}`}
                                options={headersColumn}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                inputValue={elementValue.labelElement || ''}
                                
                                onInputChange={HandleAutoComplete}
                                size='small'
                            />
                        </Grid>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                elementValue.type === 'number' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='number'
                                />:elementValue.type === 'date' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='date'
                                />: elementValue.type === 'mac' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={handleDatosMac}
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}     
                                />:
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                />
                            }
                            
                        </Grid>
                        <Grid item xl={2} lg={2} md={2} sm={2} xs={2} >
                            <TextField
                                id={`selectElement-${index}`}
                                select
                                value={elementValue.selectElement || ''}
                                onChange={HandleSelectElement}
                                style={{marginTop:8}}
                                onBlur={HandlePreAddInfFilter}
                            >
                                <MenuItem value={'O'}>O</MenuItem>
                                <MenuItem value={'Y'}>Y</MenuItem>
                            </TextField>
                            <IconButton onClick={HandlePreDeleteFilter} style={{marginTop:5}} id={`bu-${index}`}>
                                <DeleteIcon style={{color:'red'}}/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>                                
            )
        }
    };

    const Roow = memo((props)=>{
        const { 
            enqueueSnackbar,
            handleAddRow,
            handleClickRow, 
            handleDeleteRow,
            handleEditRow, 
            headCells, 
            index, 
            row,
            selectionArr,
            variablesObject, 
            marcas,
            tipos
        } = props;
        const { apiSecondIsFetch } = variablesObject;
        const [ statusRow, setStatusRow ] = useState(false);
        const [ continuoStatus, setContinuoStatus ] = useState(false);
        const [ getOpenRowDown, setOpenRowDown ] = useState(false);
        const [ getDataSecond, setDataSecond ] = useState([]);
        const [ getOpenRowDown2, setOpenRowDown2 ] = useState(false);
        const [ isAddingEvent, setAddingEvent ] = useState(false);
        const [ page, setPage ] = useState(0);
        const [ getEventNew, setEventNew ] = useState({ Valor:0, Registro:(()=>{
            const laZona="America/Guayaquil";
            const laFecha = moment().tz(laZona).format();
            return laFecha.split('T')[0];} )()
        });
        const [ isDeletingEvent, setDeletingEvent ] = useState(false);
        const [ getStock, setStock ] = useState([]);
        const [ DatosD, setDatosD ] = useState({});
        const [ getMacsOntArr, setMacsOntArr ] = useState([]);
        const [ onlyOnts, setOnlyOnts ] = useState([]);

        useEffect(()=>{
            const arrMap = selectionArr.filter(el=>el._id === row._id);
            if(arrMap.length > 0) setStatusRow(true);
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(continuoStatus){
                setContinuoStatus(false);
                if(statusRow){
                    handleClickRow(statusRow, row)
                }else{
                    handleClickRow(statusRow, row)
                }
            }
        },[continuoStatus]); // eslint-disable-line react-hooks/exhaustive-deps 


        const handleAlertDelete = ()=>{
            Swal.fire({
                title:`DESEA ELIMINAR ESTE ${variablesObject.label.toUpperCase()}?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonColor:'#005596'
            }).then((result) => {
                if (result.isConfirmed) handleDelete()
            })
        };
    
        const handleDelete = ()=>{
            fetch(variablesObject.api,{ method:'DELETE', body: JSON.stringify(row), headers:{'Content-Type': 'application/json'}}) 
            .then(response=> response.json())
            .then(result =>{
                if(result.message){
                    Swal.fire({
                        title: result.message,
                        icon:'success',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596'
                    }).then((result) => {
                        handleDeleteRow(row.id);
                    })
                }else{
                    Swal.fire({
                        title: result.status,
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596'
                    })
                }
                
            })
        };

        const HeadCellArr = headCells.map((value, index2)=>( 
            <React.Fragment key={`${index}_${index2}_${row._id}`} >
                { value.show &&
                    <TdYounet 
                        key={`${index}_${index2}_${row._id}_Td`}
                        width={value.width} 
                        minWidth={propsWidth.general} 
                        headCells={headCells} 
                        headCell={value} 
                        valueInfo={row[value.id]}
                        fixed={value.fixed}
                        align={value.align}
                        fontSize={value.fontSize}
                        bolder={value.bolder}
                        variablesObject={variablesObject}
                        marcas={marcas}
                        tipos={tipos}
                    />
                }
            </React.Fragment>
        ));

        const HandlePreClickRow = ()=>{
            setStatusRow(!statusRow);
            setContinuoStatus(true);
        };

        const handleEdit= ()=>{
            const objeto = {...row};
            objeto.EditRowNow = true;
            handleEditRow(row.id, objeto)
        };

        const handleCopy = ()=>{        
            const objeto = {...row};
            objeto.isDuplicate = true;
            delete objeto._id;
            delete objeto.id;
            handleAddRow(objeto);
        };

        const handleCloseRowDown = ()=>{ 
            setStock([]);
            setDataSecond([]);
            setMacsOntArr([]);
            setOnlyOnts([]);
            setOpenRowDown(false); 
        };

        const handleApiSecond = ()=>{
            if(apiSecondIsFetch){
                fetch(variablesObject.apiSecond,{ method:'POST', body: JSON.stringify({idTecnico:row._id}), headers:{'Content-Type': 'application/json'}}) 
                .then(response=> response.json())
                .then(result =>{
                    if(result.status){
                        Swal.fire({
                            title: result.status,
                            icon:'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596'
                        })
                    }else{
                        setDataSecond(result);
                        setOpenRowDown(true); 
                    }
                })
            }else{
                setDataSecond(row[variablesObject.rowDown]);
                setOpenRowDown(true); 
            }
        };

        const handleFetch =()=>{
            fetch(variablesObject.apiSecond,{ method:'POST', body: JSON.stringify({idTecnico:row._id}), headers:{'Content-Type': 'application/json'}}) 
            .then(response=> response.json())
            .then(result =>{
                if(result.status){
                    Swal.fire({
                        title: result.status,
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596'
                    })
                }else{
                    setDataSecond(result);
                }
            })
        };
        
        const handleAddEvent = ()=>{ 
            setAddingEvent(true);
            const objeto = {};
            objeto.idTecnico = row._id;
            objeto.TecnicoAsignado = row.Nombres;
            objeto.idStock = DatosD.idStock;
            if(variablesObject.apiSecondTitle === 'Stock'){
                fetch(variablesObject.apiSecond,{
                    method:'PUT',
                    body: JSON.stringify(objeto),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    setAddingEvent(false);
                    if(result.message){
                        enqueueSnackbar('STOCK ACTUALIZADO',{variant:'success'});
                        setOpenRowDown2(false);
                        handleFetch();
                        setDatosD({...DatosD, Onu:'', MacOnu:'', SN:'', OnuMarca:'', idStock:'' });
                        setStock([]);
                        setOnlyOnts([]);
                    }else{
                        enqueueSnackbar(result.status,{variant:'error'});                 
                    }
                });
            }else{
                const preTotal = row.Eventos.length > 0 ? row.Eventos.map(el=> el.Valor).reduce((a,b)=>  parseInt(a) + parseInt(b)) : 0;
                const total = parseInt(preTotal) + parseInt(getEventNew.Valor);
                if(total  > row.Valor){
                    enqueueSnackbar('ERROR SOBREPASA EL TOTAL DE INSTALACION', {variant:'error'});
                    setAddingEvent(false);
                }else if( total < row.Valor){
                    const objeto = {...getEventNew};
                    objeto.idInstalacion = row._id;
                    objeto.preId = `evento_${row._id}_${uuidv4()}`;
                    fetch('/api/Instalaciones/Eventos',{
                        method:'PUT',
                        body: JSON.stringify(objeto),
                        headers:{
                            'Content-Type': 'application/json'
                        }
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        setAddingEvent(false);
                        if(result._id){
                            enqueueSnackbar('EVENTO AÑADIDO',{variant:'success'});
                            objeto._id =result._id
                            handleCloseRowDown2();
                            setEventNew({ Valor:0, Registro:(()=>{
                                const laZona="America/Guayaquil";
                                const laFecha = moment().tz(laZona).format();
                                return laFecha.split('T')[0];} )()});
                        }else{
                            enqueueSnackbar(result.status,{variant:'error'});                 
                        }
                    });
                }else{
                    const objeto = {...row};
                    objeto.ValPagar = getEventNew.Valor;
                    objeto.preId = `evento_${row._id}_${uuidv4()}`;
                    objeto.Registro = getEventNew.Registro;
                    objeto.idInstalacion = row._id;
                    fetch('/api/Instalaciones/Pagar',{
                        method:'PUT',
                        body: JSON.stringify(objeto),
                        headers:{
                            'Content-Type': 'application/json'
                        }
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        setAddingEvent(false);
                        if(result._id){
                            enqueueSnackbar('PAGO REALIZADO',{variant:'success'});
                            objeto.idEvento =result._id;
                            // handleUpdateInst(objeto);
                            handleCloseRowDown2();
                        }else{
                            enqueueSnackbar(result.status,{variant:'error'});                 
                        }
                    });
                }
            }
        };

        const handleDeleteEvent = (idEvento_)=>{
            setDeletingEvent(true);
            if(variablesObject.apiSecondTitle === 'Stock'){
                fetch(variablesObject.apiSecond,{
                    method:'DELETE',
                    body: JSON.stringify({idStock:idEvento_}),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    setDeletingEvent(false);
                    if(result.message){
                        enqueueSnackbar('STOCK ACTUALIZADO',{variant:'success'});
                        handleFetch();
                    }else{
                        enqueueSnackbar(result.status,{variant:'error'});                 
                    }
                });
            }else{
                const objeto = {...getEventNew};
                    objeto.idInstalacion = row._id;
                    objeto.idEvento = idEvento_;
                const val1_ = row.Eventos.length === 1 ? 0 : row.Eventos.filter(el=>el._id !== idEvento_).map(el=> parseInt(el.Valor)).reduce((a,b)=> a + b);
                if(val1_ < row.Valor){
                    objeto.idServicio = row.idServicio;
                    objeto.CI = row.CI;
                    fetch('/api/Instalaciones/EventosStatus',{
                        method:'DELETE',
                        body: JSON.stringify(objeto),
                        headers:{
                            'Content-Type': 'application/json'
                        }
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        setDeletingEvent(false);
                        if(result.message){
                            enqueueSnackbar(result.message,{variant:'success'});
                        }else{
                            enqueueSnackbar(result.status,{variant:'error'});
                        }
                    });
                }else{
                    fetch('/api/Instalaciones/Eventos',{
                        method:'DELETE',
                        body: JSON.stringify(objeto),
                        headers:{
                            'Content-Type': 'application/json'
                        }
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        setDeletingEvent(false);
                        if(result.message){
                            enqueueSnackbar(result.message,{variant:'success'});
                            // handleDeleteEv(objeto);
                        }else{
                            enqueueSnackbar(result.status,{variant:'error'});
                        }
                    });
                }
            }
            
        };

        const handleNextPage = ()=>{ setPage(page + 1); };
        
        const handleBackPage = ()=>{ setPage(page - 1); };

        const handleOpenRowDown2 = async ()=>{ 
            if(variablesObject.apiSecondTitle === 'Stock'){
                const getStock_ = await fetch('/api/Stocks');
                const jsnStock_ = await getStock_.json();
                setStock(jsnStock_);
                const getModels = [...new Set(jsnStock_.map(el=>el.Modelo))];
                setOnlyOnts(getModels);
                setOpenRowDown2(true);
            }else{
                setOpenRowDown2(true); 
            }
        };

        const handleCloseRowDown2 = ()=>{ setOpenRowDown2(false); };

        // const handleInfoEvent = ({target})=>{ setEventNew({...getEventNew, [target.name]:target.value })}

        const handlePagar = ()=>{
            const preTotal = row.Eventos.length > 0 ?row.Eventos.map(el=> el.Valor).reduce((a,b)=>  parseInt(a) + parseInt(b)) : 0;
            const val_1 = parseInt(preTotal);
            const val_2 = parseInt(row.Valor);
            if(val_1 < val_2){
                const laZona="America/Guayaquil";
                const laFecha = moment().tz(laZona).format();
                const Total_ = val_2 - val_1;
                const objeto = {...row};
                objeto.ValPagar = Total_;
                objeto.preId = `evento_${row._id}_${uuidv4()}`;
                objeto.Registro = laFecha.split('T')[0];
                objeto.idInstalacion = row._id;
                fetch('/api/Instalaciones/Pagar',{
                    method:'PUT',
                    body: JSON.stringify(objeto),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    setAddingEvent(false);
                    if(result._id){
                        enqueueSnackbar('PAGO REALIZADO',{variant:'success'});
                        objeto._id =result._id;
                        // handleUpdateInst(objeto);
                    }else{
                        enqueueSnackbar(result.status,{variant:'error'});                 
                    }
                });
            }else{
                enqueueSnackbar('TOTAL EVENTOS SOBREPASAN INSTALACION', {variant:'error'});
            }
        };

        const handleOnus = (e, value, reason)=>{
            if(reason === 'select-option'){
                setDatosD({...DatosD, Onu:value, MacOnu:'', SN:'', OnuMarca:'', idStock:'' });
                const arr = getStock.filter(elStock=> elStock.Modelo === value);
                const arr1 = arr.filter(elStock=> elStock.Mac !== null && elStock.Mac !== undefined && elStock.Mac !== '');
                setMacsOntArr(arr1.filter(el=>el.Status === 'Disponible' && !el.idTecnico));
            }else{
                setDatosD({...DatosD, Onu:'', MacOnu:'', SN:'', OnuMarca:'', idStock:'' })
                setMacsOntArr([]);
            }
        };

        const handleSelectMacOnu = (e, value, reason)=>{ 
            if(value !== ''){
                const arrFilter = getStock.filter(el=> el.Mac === value);
                if(arrFilter.length > 0 ){
                    setDatosD({...DatosD, MacOnu:value, SN:arrFilter[0].SN, OnuMarca:arrFilter[0].Marca, idStock:arrFilter[0]._id });
                }else{
                    setDatosD({...DatosD, MacOnu:value, SN:'', OnuMarca:'', idStock:'' });
                }
            }else{
                setDatosD({...DatosD, MacOnu:'', SN:'', OnuMarca:'', idStock:'' });
            }
        };

        const handleClose = ()=>{

        };

        return(
            <TrYounetStyled key={`fila-${row._id}`}  selected={statusRow}>
                <ModalAntd 
                    title={variablesObject.apiSecondTitle} 
                    visible={getOpenRowDown} 
                    onCancel={handleCloseRowDown} 
                    okText={variablesObject.apiSecondOkTitle} 
                    onOk={variablesObject.apiSecondType === 'Stock' ? handleClose : handlePagar}
                    okButtonProps={{disabled: variablesObject.apiSecondOk ? true : row.Status === 'Pagado' ? true : false  }}
                    width={variablesObject.apiSecondWidth}
                >             
                {
                    variablesObject.isSecondApi ? 
                    <Grid container spacing={2} justifyContent='space-between' >
                        <Grid item xs={12}>                   
                            <table style={{padding:5, width:'100%', minHeight:360, overflow:'auto' }} border="1" borderColor='WhiteSmoke'> 
                                <thead>
                                    <tr 
                                        style={{
                                            display:'flex'
                                        }}
                                    >
                                        <th 
                                            style={{
                                                display:'block',
                                                height:50,
                                                maxHeight:50,
                                                minWidth:100, 
                                                textAlign:'center', 
                                                padding:5,
                                                width:100, 
                                            }}
                                        >
                                            { < Chip label='Action' color='secondary' />}
                                        </th>
                                        {
                                            variablesObject.apiSecondHeaders.map(el=>(
                                                <th 
                                                    key={`${el}_headerApiSecond`}
                                                    style={{
                                                        display:'block',
                                                        height:50,
                                                        maxHeight:50,
                                                        minWidth:250, 
                                                        padding:5,
                                                        textAlign:'start', 
                                                        width:250,
                                                    }}
                                                >
                                                    {< Chip label={el} color='primary' />}
                                                </th>
                                            ))
                                        }
                                    </tr>
                                </thead>
                                <tbody style={{minHeight:320, height:320}}>
                                    {
                                        getDataSecond
                                        .slice(page * 8, page * 8 + 8)
                                        .map((el, index)=>( 
                                            <tr 
                                                key={`row_Ev_${index}_0_`} 
                                                style={{
                                                    display:'flex'
                                                }}
                                            >
                                                <td 
                                                    style={{
                                                        display:'block',
                                                        height:40,
                                                        maxHeight:40,
                                                        minWidth:100, 
                                                        textAlign:'center', 
                                                        padding:5,
                                                        width:100, 
                                                    }}
                                                >
                                                    <Popconfirm
                                                        title="DESEA ELIMINAR?"
                                                        onConfirm={()=>{handleDeleteEvent(el._id)}}
                                                        okText="SI"
                                                        cancelText="NO"
                                                    >
                                                            <IconButton size='small' >
                                                                {isDeletingEvent ? <LoadingOutlinedIcon /> : <DeleteIcon style={{color:'red'}} />}
                                                            </IconButton>
                                                    </Popconfirm>
                                                </td>
                                                {
                                                    variablesObject.apiSecondHeaders.map(el2=>(
                                                        <td 
                                                            key={`${el2._id}_rowApiSecond`} 
                                                            style={{
                                                                display:'block',
                                                                height:40,
                                                                maxHeight:40,
                                                                minWidth:250, 
                                                                padding:5,
                                                                textAlign:'start', 
                                                                width:250,
                                                            }}
                                                        >
                                                            { el[el2] ? el[el2] : '' } 
                                                        </td>
                                                    ))
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table> 
                        </Grid>
                        <Grid item xs={2} style={{display:'flex', justifyContent:'center', alignItems:'center'}}> 
                            <TooltipAntd title="AÑADIR EVENTO" color='purple' placement='right'>
                                <Popconfirm
                                    title="DESEA AÑADIR?"
                                    onConfirm={handleOpenRowDown2}
                                    okText="SI"
                                    cancelText="NO"
                                >
                                    <ButtonAntd shape='circle' type="primary" icon={isAddingEvent ? <LoadingOutlinedIcon /> : <AppstoreAddOutlinedIcon />} size='large' disabled={row.Status === 'Pagado' ? true: false  } />
                                </Popconfirm>
                            </TooltipAntd>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper variant="outlined" style={{padding:10, width:'100%', minHeight:50}} >
                                <Grid container spacing={2} justifyContent='center'>
                                    <Grid item>
                                        <IconButton disabled={page === 0 ? true : false}  onClick={handleBackPage}>
                                            <ChevronLeftIcon/>
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        {
                                            apiSecondIsFetch ?
                                            <IconButton  
                                            disabled={(Math.ceil(getDataSecond.length / 8)) === (page + 1) ? true : getDataSecond.length <= 8 ? true : false}
                                                onClick={handleNextPage}
                                            >
                                                <ChevronRightIcon/>
                                            </IconButton> :
                                            <IconButton disabled={(Math.ceil(row[variablesObject.rowDown].length / 8)) === (page + 1) ? true : row[variablesObject.rowDown].length <= 8 ? true : false} onClick={handleNextPage}>
                                                <ChevronRightIcon/>
                                            </IconButton>
                                        }
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>     : null
                }  
                                                 
                </ModalAntd> 
                <ModalAntd 
                    onCancel={handleCloseRowDown2} 
                    onOk={handleAddEvent} 
                    okText={'ADD'} 
                    title={`ADD ${variablesObject.apiSecondTitle?.toUpperCase()}`}
                    visible={getOpenRowDown2} 
                    width={700}
                >                
                    <Grid container spacing={2} justifyContent='space-between' style={{padding:5, width:'100%', border:'1px solid #D0D3D4', borderRadius:5}}>
                        <Grid item sm={6} xs={12} >
                            <Autocomplete
                                id='Onu'                                            
                                options={onlyOnts}
                                value={DatosD.Onu || ''}
                                onChange={handleOnus}
                                renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps,
                                    startAdornment: <RouterIcon/>,
                                }} fullWidth label="ONU" variant="outlined" required size='small' margin='dense'/>}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12} >
                            <Autocomplete
                                id='MacOnu'                                            
                                options={getMacsOntArr}
                                inputValue={DatosD.MacOnu || ''}
                                onInputChange={handleSelectMacOnu}
                                getOptionLabel={(option) => option.Mac}
                                renderOption={(option) => (
                                    <span style={{color: option.Status === 'Disponible' ? 'green' : option.Status === 'No Disponible' ? 'red' : 'orange'}}>{option.Mac}</span>
                                )}
                                renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <RouterIcon/>,}} margin='dense' fullWidth label="Mac Onu" variant="outlined" required size='small'/>}
                            />
                        </Grid>
                    </Grid>                                  
                </ModalAntd> 
                <TdYounetStyled 
                    minWidth={variablesObject.widthAction} 
                    width={variablesObject.widthAction}
                    paddingTop='0px'
                    padding='0px'
                    isMultiline={variablesObject.isMultiline}
                    >
                    <Grid 
                        alignItems='center'
                        container 
                        spacing={0} 
                        style={{height:43}} 
                    >
                        <Grid item >
                            <Checkbox
                                checked={statusRow}
                                color='primary'
                                onClick={HandlePreClickRow}
                                style={{marginTop:-4}}
                                size='small'
                            />
                        </Grid>
                        <Grid item>
                            <Tooltip title={`EDITAR`} placement='top' arrow>
                                <span>
                                <IconButton color='primary' onClick={handleEdit} size='small'>
                                    <EditIcon/>
                                </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                        <Grid item >
                            <Tooltip title={`ELIMINAR`} placement='top' arrow>
                                <span>
                                    <IconButton aria-label="expand row" size="small" onClick={handleAlertDelete} color='primary'>
                                        <DeleteIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Grid> 
                        <Grid item >
                            <Tooltip title={`DUPLICAR`} placement='top' arrow>
                                <span>
                                    <IconButton aria-label="expand row" size="small" onClick={handleCopy} color='primary' style={{color:'dodgerblue'}}>
                                        <ContentCopyIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Grid> 
                        {
                            variablesObject.isRowDown &&
                            <Grid item >
                                <Tooltip title={variablesObject.rowDown} placement='top' arrow>
                                    <span>
                                        <IconButton aria-label="expand row" size="small" onClick={handleApiSecond} color='primary'>
                                            {
                                                variablesObject.apiSecondIcon === 'RouterIcon'
                                                ? <RouterIcon />
                                                : <FilterNoneIcon/>
                                            }
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </Grid>
                        } 
                    </Grid>
                </TdYounetStyled>
                { HeadCellArr }
            </TrYounetStyled>
        );
    });

    const RowNew = ({
        arrInfoSelect, 
        Empresa,
        getArrMac, 
        handleDeleteRowNew,
        handleSaveRowNew, 
        headCells, 
        index, 
        row, 
        variablesObject,
        marcas,
        tipos
    })=>{
        const [ dataRow, setDataRow ] = useState({Nombre:'', Direccion:'', Correo:'', Celuar:''});
        const { enqueueSnackbar } = useSnackbar();

        useEffect(()=>{
            if(row.isDuplicate){
                setDataRow(row);
            }
        },[])  // eslint-disable-line react-hooks/exhaustive-deps

        const handleRowNew = useCallback((idEl, value)=>{
                setDataRow({...dataRow, [idEl]:value});
        },[dataRow]);


        const HeadCellArr = headCells.map((value, index2)=>( 
            <React.Fragment key={`${index}_${index2}_${row._id}`} >
                {   
                    value.show &&
                    <React.Fragment>
                        {
                            value.type === 'Mac' ? 
                            <TdYounetEditMac
                                key={`${index}_${index2}_${row._id}_Td`}
                                width={value.width} 
                                minWidth={propsWidth[value.id]} 
                                headCells={headCells} 
                                headCell={value} 
                                fixed={value.fixed}
                                align={value.align}
                                fontSize={value.fontSize}
                                bolder={value.bolder}
                                idEl={value.id}
                                handleRowNew={handleRowNew} 
                                isModeEdit={false}
                                getArrMac={getArrMac}
                                valueInfo={row.isDuplicate ? row[value.id] : dataRow[value.id] }
                            />:
                            value.type === 'date' ? 
                            <TdYounetEditFecha
                                key={`${index}_${index2}_${row._id}_Td_Fecha`}
                                width={value.width} 
                                minWidth={propsWidth[value.id]} 
                                headCells={headCells} 
                                headCell={value} 
                                fixed={value.fixed}
                                align={value.align}
                                fontSize={value.fontSize}
                                bolder={value.bolder}
                                idEl={value.id}
                                handleRowNew={handleRowNew}
                                valueInfo={row.isDuplicate ? row[value.id] : dataRow[value.id] }
                            />:
                            value.type === 'switch' ? 
                            <TdYounetEditSwitch
                                key={`${index}_${index2}_${row._id}_Td`}
                                width={value.width} 
                                minWidth={propsWidth[value.id]} 
                                headCells={headCells} 
                                headCell={value} 
                                fixed={value.fixed}
                                align={value.align}
                                fontSize={value.fontSize}
                                bolder={value.bolder}
                                idEl={value.id}
                                handleRowNew={handleRowNew}
                                valueInfo={row.isDuplicate ? row[value.id] : dataRow[value.id] }
                            />:
                            value.type === 'select' ? 
                            <TdYounetEditSelect
                                key={`${index}_${index2}_${row._id}_Td`}
                                width={value.width} 
                                minWidth={propsWidth[value.id]} 
                                headCells={headCells} 
                                headCell={value} 
                                fixed={value.fixed}
                                align={value.align}
                                fontSize={value.fontSize}
                                bolder={value.bolder}
                                idEl={value.id}
                                handleRowNew={handleRowNew}
                                arrInfoSelect={arrInfoSelect}
                                valueInfo={row.isDuplicate ? row[value.id] : dataRow[value.id] }
                            />:
                            <TdYounetEdit
                                key={`${index}_${index2}_${row._id}_Td`}
                                width={value.width} 
                                minWidth={propsWidth.general} 
                                headCells={headCells} 
                                headCell={value} 
                                fixed={value.fixed}
                                align={value.align}
                                fontSize={value.fontSize}
                                bolder={value.bolder}
                                idEl={value.id}
                                handleRowNew={handleRowNew}
                                valueInfo={row.isDuplicate ? row[value.id] : dataRow[value.id] }
                                variablesObject={variablesObject}
                                marcas={marcas}
                                tipos={tipos}
                            />
                        }
                    </React.Fragment>    
                }
            </React.Fragment>
        ));

        const handleSave = ()=>{
            const objeto = {...dataRow};
            objeto.id = row.id;
            objeto.Empresa = Empresa;
            delete objeto._id;
            fetch(variablesObject.api,{ method:'POST', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
            .then(response=> response.json())
            .then(result =>{
                if(result._id){
                    const objeto = {...result};
                    objeto.ColNew = false;
                    handleSaveRowNew(result.id, objeto);
                    enqueueSnackbar(`${variablesObject.label.toUpperCase()} AGREGADO`, {variant:'success'});
                }else{
                    Swal.fire({
                        title: result.status,
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596'
                    })
                }
                
            })
            
        };

        return(
            <TrYounetStyled key={`fila-${row._id}`} >
                <TdYounetStyled2 
                    minWidth={variablesObject.widthAction} 
                    width={variablesObject.widthAction} 
                >
                    <Grid container spacing={0} justifyContent='center' >
                        <Grid item>
                            <Tooltip title={`GUARDAR ${variablesObject.label.toUpperCase()}`} placement='top' arrow>
                                <span>
                                <IconButton color='primary' onClick={handleSave} size='small' >
                                    <CheckIcon/>
                                </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                        <Grid item>
                            <Tooltip title={`CANCELAR`} placement='top' arrow>
                                <span>
                                <IconButton color='primary' onClick={handleDeleteRowNew} size='small' >
                                    <CancelIcon/>
                                </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </TdYounetStyled2>
                { HeadCellArr }
            </TrYounetStyled>
        );
    };

    const RowEdit = ({ 
        arrInfoSelect,
        getArrMac,
        handleSaveRowNew, 
        headCells, 
        index,
        row, 
        variablesObject,
        marcas,
        tipos
    })=>{
        const [ dataRow, setDataRow ] = useState({Nombre:'', Direccion:'', Correo:'', Celuar:''});
        const [ backupRow, setBackupRow ] = useState({Nombre:'', Direccion:'', Correo:'', Celuar:''});
        const { enqueueSnackbar } = useSnackbar();

        useEffect(()=>{
            setDataRow(row);
            setBackupRow(row);
        },[])  // eslint-disable-line react-hooks/exhaustive-deps

        const handleRowNew = useCallback((idEl, value)=>{
            setDataRow({...dataRow, [idEl]:value});
        },[dataRow]);


        const HeadCellArr = headCells.map((value, index2)=>( 
            <React.Fragment key={`${index}_${index2}_${row._id}`} >
                {   
                    value.type === 'Mac' ? 
                    <TdYounetEditMac
                        key={`${index}_${index2}_${row._id}_Td`}
                        width={value.width} 
                        minWidth={propsWidth[value.id]} 
                        headCells={headCells} 
                        headCell={value} 
                        valueInfo={dataRow[value.id]}
                        fixed={value.fixed}
                        align={value.align}
                        fontSize={value.fontSize}
                        bolder={value.bolder}
                        idEl={value.id}
                        handleRowNew={handleRowNew} 
                        isModeEdit={true}
                        valorOriginal={dataRow[value.id]}
                        getArrMac={getArrMac}
                    />:
                    value.type === 'date' ? 
                    <TdYounetEditFecha
                        key={`${index}_${index2}_${row._id}_Td_Fecha`}
                        width={value.width} 
                        minWidth={propsWidth[value.id]} 
                        headCells={headCells} 
                        headCell={value} 
                        valueInfo={dataRow[value.id]}
                        fixed={value.fixed}
                        align={value.align}
                        fontSize={value.fontSize}
                        bolder={value.bolder}
                        idEl={value.id}
                        handleRowNew={handleRowNew}
                    />:
                    value.type === 'switch' ? 
                    <TdYounetEditSwitch
                        key={`${index}_${index2}_${row._id}_Td`}
                        width={value.width} 
                        minWidth={propsWidth[value.id]} 
                        headCells={headCells} 
                        headCell={value} 
                        valueInfo={dataRow[value.id]}
                        fixed={value.fixed}
                        align={value.align}
                        fontSize={value.fontSize}
                        bolder={value.bolder}
                        idEl={value.id}
                        handleRowNew={handleRowNew}
                    />:
                    value.type === 'select' ? 
                    <TdYounetEditSelect
                        key={`${index}_${index2}_${row._id}_Td`}
                        width={value.width} 
                        minWidth={propsWidth[value.id]} 
                        headCells={headCells} 
                        headCell={value} 
                        valueInfo={dataRow[value.id]}
                        fixed={value.fixed}
                        align={value.align}
                        fontSize={value.fontSize}
                        bolder={value.bolder}
                        idEl={value.id}
                        handleRowNew={handleRowNew}
                        arrInfoSelect={arrInfoSelect}
                    />:
                    value.show &&
                    <TdYounetEdit
                        key={`${index}_${index2}_${row._id}_Td`}
                        width={value.width} 
                        minWidth={propsWidth.general} 
                        headCells={headCells} 
                        headCell={value} 
                        fixed={value.fixed}
                        align={value.align}
                        fontSize={value.fontSize}
                        bolder={value.bolder}
                        idEl={value.id}
                        handleRowNew={handleRowNew}
                        valueInfo={row[value.id]}
                        variablesObject={variablesObject}
                        marcas={marcas}
                        tipos={tipos}
                    />    
                }
            </React.Fragment>
        ));

        const handleSave = ()=>{
            fetch(variablesObject.api,{ method:'PUT', body: JSON.stringify(dataRow), headers:{'Content-Type': 'application/json'}}) 
            .then(response=> response.json())
            .then(result =>{
                if(result.message){
                    const objeto = {...dataRow};
                    objeto.ColNew = false;
                    objeto.EditRowNow = false;
                    handleSaveRowNew(row.id, objeto);
                    enqueueSnackbar(result.message, {variant:'success'});
                }else{
                    Swal.fire({
                        title: result.status,
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596'
                    })
                }
                
            })
        };

        const handleCancelar = ()=>{
            setDataRow(backupRow);
            const objeto = {...backupRow};
            objeto.ColNew = false;
            objeto.EditRowNow = false;
            objeto._id = row._id;
            handleSaveRowNew(row.id, objeto);
        };

        return(
            <TrYounetStyled key={`fila-${row._id}`} >
                <TdYounetStyled2 
                    minWidth={variablesObject.widthAction} 
                    width={variablesObject.widthAction} 
                >
                    <Grid container spacing={0} justifyContent='center'>
                        <Grid item>
                            <Tooltip title={`GUARDAR ${variablesObject.label.toUpperCase()}`} placement='top' arrow>
                                <span>
                                <IconButton color='primary' onClick={handleSave} size='small' >
                                    <CheckIcon/>
                                </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                        <Grid item>
                            <Tooltip title={`CANCELAR`} placement='top' arrow>
                                <span>
                                <IconButton color='primary' onClick={handleCancelar} size='small' >
                                    <CancelIcon/>
                                </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </TdYounetStyled2>
                { HeadCellArr }
            </TrYounetStyled>
        );
    };

    const RowHeadersStyle = memo(({rowInfo, HandleProcessHeaders, headCellsColumn})=>{

        const { id, numeric, disablePadding, label, show, fixed, width, num, align, fontSize, bolder, type } = rowInfo;
        const [ infoRow, setInfoRow ] = useState({ id, numeric, disablePadding, label, show, fixed, width, num, align, fontSize, bolder, type });

        const HandleInformacion = (e)=>{
            setInfoRow({...infoRow, [e.target.name]:e.target.value})
        };

        const HandleSwitch = (e)=>{
            setInfoRow({...infoRow, bolder:e.target.checked})
        };

        const HandleProcess = ()=>{
            HandleProcessHeaders(infoRow);
        };

        const handleChangeWidth = (e, value)=>{
            setInfoRow({...infoRow, width:value})
        };

        const HandleReset = ()=>{
            const element = headCellsColumn.filter(value=> value.id === rowInfo.id)[0];
            HandleProcessHeaders(element);
        };

        return(
            <Paper elevation={2} style={{width:'100%', padding:10}}>
                <Grid container spacing={1}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2} style={{height:40}}>
                            <Grid item style={{marginTop:2}}>
                                <Button size='small' variant='contained' color='primary' onClick={HandleProcess} endIcon={<SaveIcon/>}> GUARDAR </Button> 
                            </Grid>
                            <Grid item style={{marginTop:2}}>
                                <Button size='small' variant='contained' color='primary' onClick={HandleReset} endIcon={<AutorenewIcon/>}> RESET </Button> 
                            </Grid>
                            <Grid item style={{textTransform:'uppercase', fontWeight:'bolder'}}>
                                <Chip label={rowInfo.label}  color='secondary'/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <TextField 
                            id={`${rowInfo.id}_${rowInfo.label}`}
                            name={'align'}
                            value={infoRow.align ||''}
                            onChange={HandleInformacion}
                            fullWidth
                            margin='dense'
                            variant='outlined'
                            label='Alinear Texto'
                            select
                        >
                            <MenuItem  value={'left'}>
                                IZQUIERDA
                            </MenuItem>
                            <MenuItem  value={'center'}>
                                CENTRADO
                            </MenuItem>
                            <MenuItem  value={'right'}>
                                DERECHA
                            </MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item>
                        <TextField 
                            id={`${rowInfo.id}_${rowInfo.label}`}
                            name={'fontSize'}
                            value={infoRow.fontSize ||''}
                            onChange={HandleInformacion}
                            fullWidth
                            margin='dense'
                            variant='outlined'
                            label='Tamaño Texto'
                        />
                    </Grid>
                    <Grid item style={{width:100}}>
                        <Slider 
                            value={infoRow.width} 
                            onChange={handleChangeWidth} 
                            aria-labelledby="continuous-slider" 
                            step={5}
                            min={50}
                            max={600}
                        />
                        <p>Ancho:{infoRow.width}</p>
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            control={
                            <Switch
                                checked={infoRow.bolder}
                                onChange={HandleSwitch}
                                id={`${rowInfo.id}_${rowInfo.label}`}
                                color="primary"
                            />
                            }
                            label={'Negritas'}
                        />
                    </Grid>
                </Grid>
            </Paper>
        );      
    });

    const Elemento = (props)=>{
        const { headCellsColumn, variablesObject, arrInfoSelect, getArrMac, widthWin, marcas=[], tipos=[] } = props.info
        const classes = useStyles();
        const { setOpen, authTokens, setRuta } = useAuth();
        const { enqueueSnackbar } = useSnackbar();
        const [ rows, setRows ] = useState([]);
        const [ backupsRow, setBackupsRow ] = useState([]);
        const [ order, setOrder] = useState(variablesObject.order ? variablesObject.order : 'asc');
        const [ orderBy, setOrderBy] = useState(variablesObject.orderBy ? variablesObject.orderBy : 'Nombres');
        const [ page, setPage] = useState(0);
        const [ rowsPerPage, setRowsPerPage] = useState(widthWin === 'xs' ? 10 : 14);
        const [ headersColumn, setHeadersColumn ] = useState(()=>{
            try{
                if(window.localStorage.getItem(variablesObject.nameLocalStorage)){
                    const headersStorage = window.localStorage.getItem(variablesObject.nameLocalStorage) ;
                    const headersParse = JSON.parse(headersStorage);
                    return headersParse
                }else{
                    return headCellsColumn
                }
            }catch(err){
                console.log(err);
                return headCellsColumn
            }
        });
        const [ openMenuColumn, setOpenMenuColumn ] = useState(null);
        const [ openMenuColumnFixed, setOpenMenuColumnFixed ] = useState(null);
        const [ isSavingHeaders, setSavingHeaders ] = useState(false);
        const [ openMenuFilter, setOpenMenuFilter ] = useState(false);
        const [ openMenuDate, setOpenMenuDate ] = useState(null);
        const [ openMenuPdf, setOpenMenuPdf ] = useState(null);
        const [ openMenuExcel, setOpenMenuExcel ] = useState(null);
        const [ openMenuStyles, setOpenMenuStyles ] = useState(false);
        const [ openMenuPosicion, setOpenMenuPosicion ] = useState(false);
        const [ arrFiltrado, setArrFiltrado ] = useState([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
        const [ elementDate, setElementDate ] = useState({ idElement:'', labelElement:'', Inicio:'', Final:''});
        const [ isFilterDate, setFilterDate ] = useState(false);
        const [ isFilterNow, setFilterNow ] = useState(false);
        const [ isElementFilterShow, setElementFilterShow ] = useState(true);
        const [ rowsFilter, setRowsFilter ] = useState([]);
        const [ rowsFilterDate, setRowsFilterDate ] = useState([]);
        const [ selectionArr, setSelectionArr ] = useState([]);
        const [ isReadyPdf, setReadyPdf ] = useState(false);
        const [ isSelectPdf, setSelectPdf ] = useState(false);
        const [ isContinuoPdf, setContinuoPdf ] = useState(false);
        const [ arrHeadersPdf, setArrHeadersPdf ]= useState([])
        const [ openSelectPersonsMail, setOpenSelectPersonsMail ] = useState(false);
        const [ Remitentes, setRemitentes ] = useState([]);
        const [ RemitentesAll, setRemitentesAll ] = useState([]);
        const [ isCharging, setCharging ] = useState(true);
        const [ isNewRow, setNewRow ] = useState(false);
        const [ isEditRow, setEditRow ] = useState(false);
        const [ getContinuoUnSelect, setContinuoUnSelect ] = useState(false);
        const [ isShowBusqueda, setShowBusqueda ] = useState(true);
        const [ openMenuBusqueda, setOpenMenuBusqueda ] = useState(null);
        const [ getSearch, setSearch ] = useState('');
        const [ getOptionSearch, setOptionSearch ] = useState(variablesObject.OptionSearch || headCellsColumn[0].id); 
        
        useEffect(()=>{
            const handleUseEffect = async ()=>{
                setOpen(false); 
                setRuta(variablesObject.Ruta || '');
                const dataUser = await fetch('/api/users');
                const infoUser = await dataUser.json();
                const arrMails = infoUser.map(elUser=> elUser.Mail);
                const dataRec = await fetch(variablesObject.apiFiltered ? `${variablesObject.apiFiltered}/${authTokens.Empresa}` : variablesObject.api );
                const infoRec = await dataRec.json();
                setRows(infoRec.filter(el=> el.Empresa === authTokens.Empresa));
                setBackupsRow(infoRec.filter(el=> el.Empresa === authTokens.Empresa));
                setRemitentesAll(arrMails);
                setTimeout(()=>{
                    setCharging(false);
                },500); 
            };
            
            handleUseEffect();

        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(isContinuoPdf){
                setContinuoPdf(false);
                setReadyPdf(true);
            }
        },[isContinuoPdf]); // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(getContinuoUnSelect){
                setContinuoUnSelect(false);
                setRows(backupsRow);
            }
        },[getContinuoUnSelect, backupsRow]);
        
        const handleClickMenu = (event) => { setOpenMenuColumn(event.currentTarget); };

        const handleClickMenuFixed = (event) => { setOpenMenuColumnFixed(event.currentTarget);};

        const handleClickMenuFilter = (event) => {
            setOpenMenuFilter(true);
            setElementFilterShow(true);
        };

        const handleClickMenuDate = (event) => { setOpenMenuDate(event.currentTarget);};

        const handleClickMenuPdf = (event) => { setOpenMenuPdf(event.currentTarget);};

        const handleClickMenuExcel = (event) => {setOpenMenuExcel(event.currentTarget);};

        const handleCloseMenu = () => {setOpenMenuColumn(null)};

        const handleCloseMenuFixed = () => { setOpenMenuColumnFixed(null) };

        const handleCloseMenuFilter = () => {
            setOpenMenuFilter(false);
            setElementFilterShow(false);
        };

        const handleCloseMenuDate = () => { setOpenMenuDate(null) };

        const handleCloseMenuPdf = ()=> { setOpenMenuPdf(null) };

        const handleCloseMenuExcel = ()=> { setOpenMenuExcel(null) };

        const handleRequestSort = useCallback((event, property) => {
            const isAsc = orderBy === property && order === 'asc';
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(property);
        },[order, orderBy])
            
        const handleChangePage = (event, newPage) => { setPage(newPage) };
        
        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        };
    
        const HandleChangeSwitch = (e)=>{
            const arrMap = headersColumn.map(value=>{
                if(value.id === e.target.name){
                    let objeto = {...value};
                    objeto.show = e.target.checked;
                    return objeto;
                }else{
                    return value;
                }
            });
            setHeadersColumn(arrMap);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(arrMap))
        };
        
        const ElementMenu = headersColumn.map((value,index)=>
                <MenuItem key={`ElementMenu-${index}`}>
                    <FormControlLabel
                        control={
                        <Switch
                            checked={value.show}
                            onChange={HandleChangeSwitch}
                            name={value.id}
                            color="primary"
                        />
                        }
                        label={value.label}
                    />
                </MenuItem>
        );

        const HandleChangeSwitchFixed = (e)=>{
            const arrMap = headersColumn.map(value=>{
                if(value.id === e.target.name){
                    let objeto = {...value};
                    objeto.fixed = e.target.checked;
                    return objeto;
                }else{
                    return value;
                }
            });
            setHeadersColumn(arrMap);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(arrMap))
            setSavingHeaders(true);
            setOpenMenuColumnFixed(false)
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000)
        };

        const ElementMenuFixed = headersColumn.map((value,index)=>( 
                <MenuItem key={`ElementMenuFixed-${index}`}>
                    <FormControlLabel
                        control={
                        <Switch
                            checked={value.fixed}
                            onChange={HandleChangeSwitchFixed}
                            name={value.id}
                            color="primary"
                        />
                        }
                        label={value.label}
                    />
                </MenuItem>
        ));

        const HandleAddInformacionFilter = useCallback((objeto)=>{
            const arrF = arrFiltrado.map((value,index)=> {
                if(objeto.numero === index){
                    return objeto
                }else{
                    return value
                }
            })
            setArrFiltrado(arrF);
        },[arrFiltrado]);

        const HandleDeleteFilter = useCallback((infElement)=>{ 
            const arrF = arrFiltrado.filter((value,index)=> infElement !== index);
            setArrFiltrado(arrF);
        },[arrFiltrado]);

        const HandleAddFilter = useCallback(()=>{
            const cant = arrFiltrado.length;
            setArrFiltrado([...arrFiltrado, {numero:cant, valueElement:'', idElement:'', labelElement:'', selectElement:'O'} ]);
        },[arrFiltrado]);


        const ElementMenuFilter = arrFiltrado.map((value,index)=>
            <FiltradoEl 
                key={`filterElement-${index}`} 
                index={index} 
                info={value} 
                HandleAddFilter={HandleAddFilter} 
                HandleDeleteFilter={HandleDeleteFilter}
                HandleAddInformacionFilter={HandleAddInformacionFilter}
                headersColumn={headersColumn}
        />);

        const HandleProcessFilterElement = ()=>{
            const arrInfo = isFilterDate ? [...rows] : [...backupsRow];
            if(isFilterNow){
                console.log('isFilterNow');
                let dataNow = [ ];
                arrFiltrado.forEach((value,index)=>{
                    if(index === 0){
                        if(value.type === 'number'){
                            arrInfo.forEach((value2)=>{
                                if(value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))) dataNow.push(value2);
                            });
                        }else if(value.type === 'text'){
                            arrInfo.forEach((value2)=>{
                                if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))) dataNow.push(value2);
                            });
                        }else{
                            arrInfo.forEach((value2)=>{
                                if(value2[value.idElement] && (value2[value.idElement].toString() === value.valorElement.toString()))  dataNow.push(value2);
                            });
                        }
                    }else{
                        if(value.type === 'number'){
                            if(value.selectElement === 'O'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))) dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))
                                );
                            }
                        }else if(value.type === 'text'){
                            if(value.selectElement === 'O'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))) dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))
                                );
                            }          
                        }else{
                            if(value.selectElement === 'O'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase()))  dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    value2[value.idElement] && (value2[value.idElement].toString() === value.valorElement.toString())
                                );
                            }
                                
                        }
                    }
                }); 
                let hash = {};
                dataNow = dataNow.filter(o => hash[o._id] ? false : hash[o._id] = true);
                setRows(dataNow);
                setRowsFilter(dataNow);
            }else{
                console.log('!isFilterNow');
                console.log(arrFiltrado)
                if(arrFiltrado[0].valorElement === ''){
                    setOpenMenuFilter(false);
                    setTimeout(()=>{
                        Swal.fire({
                            title:'NO HAY ELEMENTOS QUE FILTRAR',
                            toast:true,
                            confirmButtonColor:'#0E3B5F',
                        });
                    },200);
                    
                }else{
                    let dataNow = [ ];
                    arrFiltrado.forEach((value,index)=>{
                        if(index === 0){
                            console.log('index0');
                            if(value.type === 'number'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (parseInt(value2[value.idElement]) === parseInt(value.valorElement))) dataNow.push(value2);
                                });
                            }else if(value.type === 'text'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))){ 
                                        dataNow.push(value2);
                                        console.log(value2);
                                    }
                                });
                            }else{
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString() === value.valorElement.toString()))  dataNow.push(value2);
                                });
                            }
                        }else{
                            console.log('!index0');
                            if(value.type === 'number'){
                                if(value.selectElement === 'O'){
                                    arrInfo.forEach((value2)=>{
                                        if(value2[value.idElement] && (parseInt(value2[value.idElement]) === parseInt(value.valorElement))) dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))
                                    );
                                }
                            }else if(value.idElement === 'text'){
                                if(value.selectElement === 'O'){
                                    arrInfo.forEach((value2)=>{
                                        if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))) dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))
                                    );
                                } 
                            }else{
                                if(value.selectElement === 'O'){
                                    arrInfo.forEach((value2)=>{
                                        if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase()))  dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        value2[value.idElement] && (value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase())
                                    );
                                }  
                            }
                        }
                    }); 
                    let hash = {};
                    dataNow = dataNow.filter(o => hash[o._id] ? false : hash[o._id] = true);
                    setFilterNow(true);
                    setRows(dataNow);
                    setRowsFilter(dataNow);
                }
            }
        };

        const HandleResetFilter = ()=>{
            setElementFilterShow(false);
            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}])
            setFilterNow(false);
            if(isFilterDate){
                setRows(rowsFilterDate);
            }else{
                setRows(backupsRow);
            }
            setTimeout(()=>{
                setElementFilterShow(true);
            },1000)
        };

        const HandleMenuDate = (e)=>{ setElementDate({...elementDate, [e.target.id]:e.target.value })};

        const HandleClearDate = ()=>{
            setElementDate({});
            setOpenMenuDate(null);
            setFilterDate(false);
        };

        const HandleProcessFilterDate = ()=>{
            if(elementDate.Inicio === '' || elementDate.Final === ''){
                if(elementDate.Inicio === ''){
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'FECHA DE INICIO REQUERIDA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }else{
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'FECHA DE FINAL REQUERIDA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }
            }else{
                const resultInicio = new Date(elementDate.Inicio)
                const resultFinal = new Date(elementDate.Final)
                if(elementDate.idElement === ''){
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'DEBE SELECCIONAR UNA FILA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }else{ 
                    if(resultInicio > resultFinal){ 
                        setOpenMenuDate(null);
                        Swal.fire({
                            title:'FECHA DE INICIO DEBE SER MENOR A LA FECHA FINAL',
                            toast:true,
                            confirmButtonColor:'#0E3B5F',
                            width:'450px'
                        });
                    }else{
                        if(isFilterNow){
                            const arrFil = [];
                            for(const a in rows){
                                const el ={...rows[a]};
                                const dataEl = el[elementDate.idElement];
                                if(dataEl !== null){  
                                    if(dataEl !== undefined){       
                                        if(dataEl !== ''){ 
                                            if(dataEl.length <= 10){
                                                const valFecha = new Date(dataEl)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha <= resultFinal) arrFil.push(el);
                                                } 
                                            }else{
                                                const valFecha2 = dataEl.split("T")[0].toString();
                                                const valFecha = new Date(valFecha2)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha.getTime() <= resultFinal.getTime()) arrFil.push(el);
                                                } 
                                            }
        
                                        }                  
                                    }}
                            }    
                            if(arrFil.length === 0){
                               alert('NO HAY ELEMENTOS QUE VISUALIZAR')
                            }else{
                                setFilterDate(true);
                                setOpenMenuDate(null);
                                setRows(arrFil);
                                setRowsFilterDate(arrFil);
                            } 
                        }else{
                            const arrFil = [];
                            for(const a in backupsRow){
                                const el ={...backupsRow[a]};
                                const dataEl = el[elementDate.idElement];
                                if(dataEl !== null){  
                                    if(dataEl !== undefined){       
                                        if(dataEl !== ''){ 
                                            if(dataEl.length <= 10){
                                                const valFecha = new Date(dataEl)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha <= resultFinal) arrFil.push(el);
                                                } 
                                            }else{
                                                const valFecha2 = dataEl.split("T")[0].toString();
                                                const valFecha = new Date(valFecha2)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha.getTime() <= resultFinal.getTime()) arrFil.push(el);
                                                } 
                                            }
        
                                        }                  
                                    }}
                            }                           
                            if(arrFil.length === 0){
                               alert('NO HAY ELEMENTOS QUE VISUALIZAR')
                            }else{
                                setFilterDate(true);
                                setOpenMenuDate(null);
                                setRows(arrFil);
                                setRowsFilterDate(arrFil);
                            } 
                        }
                    }
                }
            }
            
        };

        const HandleResetFilterDate = ()=>{
            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''});
            setFilterDate(false);
            if(isFilterNow){
                setRows(rowsFilter)
            }else{
                setRows(backupsRow);
            }    
        };

        const HandleAutoComplete = (e, value)=>{
            if(value === '' || value === null){
                setElementDate({...elementDate, idElement:'', labelElement:'', valorElement:''});
            }else{ 
                const arrFilHeaders = headersColumn.filter(value2=> value2.label === value);
                if(arrFilHeaders.length > 0){
                    setElementDate({...elementDate, idElement:arrFilHeaders[0].id.toString(), labelElement:value});
                }  
            }
            
        };

        const handleClickRow = useCallback((statusRow, row)=>{
            if(statusRow){
                const arr = [...selectionArr];
                arr.push(row);
                setSelectionArr(arr);
            }else{
                const arr = selectionArr.filter(value=> value._id !== row._id);
                setSelectionArr(arr);
            }
        },[selectionArr]);

        const HandleExportSelectPdf = ()=>{
            if(selectionArr.length === 0){
                setOpenMenuPdf(null);
                Swal.fire({
                    title:'NO HAY ELEMENTOS A EXPORTAR',
                    toast:true,
                    confirmButtonColor:'#0E3B5F',
                });
            }else{
                if(isReadyPdf){
                    const FiltHeaders = headersColumn.filter(value=> value.show);
                    const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                    const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                    setArrHeadersPdf(FiltHeaders2);
                    setReadyPdf(false);
                    setSelectPdf(true);
                    setContinuoPdf(true);
                }else{
                    const FiltHeaders = headersColumn.filter(value=> value.show);
                    const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                    const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                    setArrHeadersPdf(FiltHeaders2);
                    setSelectPdf(true);
                    setContinuoPdf(true);
                }
                
            }
        };

        const HandleExportAllPdf = ()=>{
            if(isReadyPdf){
                const FiltHeaders = headersColumn.filter(value=> value.show);
                const FiltHeaders1 = FiltHeaders.filter(value=> value.type !== 'Action');
                const FiltHeaders2 = FiltHeaders1.filter(value=> value.type !== 'Fotos');
                setArrHeadersPdf(FiltHeaders2);
                setReadyPdf(false);
                setSelectPdf(false);
                setContinuoPdf(true);
            }else{
                const FiltHeaders = headersColumn.filter(value=> value.show);
                const FiltHeaders1 = FiltHeaders.filter(value=> value.type !== 'Action');
                const FiltHeaders2 = FiltHeaders1.filter(value=> value.type !== 'Fotos');
                setArrHeadersPdf(FiltHeaders2);
                setSelectPdf(false);
                setContinuoPdf(true);
                
            }
        };

        const HandleClickPdf = useCallback(()=>{
            setTimeout(()=>{
                setReadyPdf(false);
            },2000)
        },[]);

        const handleCloseSelectPersonsMail = ()=>{
            setOpenSelectPersonsMail(false);
        };

        const HandleRemitentes = (e, value)=>{ setRemitentes(value) };

        const HandleSelectPersonsMail = ()=>{
            if(selectionArr.length > 0){
                setOpenSelectPersonsMail(true);
            }else{
                enqueueSnackbar('SELECCIONE UNA FILA POR LO MENOS', {variant:'info'});
            }
        };

        const HandleSendCorreos = ()=>{
            fetch('/SendMailsRows',{ 
                method: 'POST',
                body: JSON.stringify({Elementos:selectionArr, headersColumn, Remitentes}),
                headers:{'Content-Type':'application/json'}
            })
            .then(response=> response.json())
            .then(result =>{
                setOpenSelectPersonsMail(false);
                enqueueSnackbar('Correos Enviados', {variant:'success'});
            });
        };
        
        const HandleProcessHeaders = useCallback((dataHeadersStyle)=>{
            const headersResultStyles = headersColumn.map(value=>{
                if(value.id === dataHeadersStyle.id){
                    return dataHeadersStyle;
                }else{
                    return value;
                }
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles))
            setSavingHeaders(true);
            setOpenMenuStyles(false)
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        },[headersColumn,variablesObject]);

        const ElementMenuStyles = headersColumn.map((value,index)=>( 
            <Grid item key={`ElementMenuStyles_${index}`} xl={12} lg={12} md={12} sm={12} xs={12} >
                <RowHeadersStyle rowInfo={value} HandleProcessHeaders={HandleProcessHeaders} headCellsColumn={headCellsColumn}/>
            </Grid>
                
        ));

        const handleOpenMenuStyles = ()=>{ setOpenMenuStyles(true) };

        const handleCloseMenuStyles = ()=>{ setOpenMenuStyles(false) };

        const handleHeadersPosicion = (e)=>{
            const idEl = e.target.id.split('_')[0];
            const arr =  headersColumn.map(value=>{
                if(value.id.toString() === idEl.toString()){
                    const objeto = {...value};
                    objeto.num = e.target.value;
                    return objeto;
                }else{
                    return value;
                }
            })
            setHeadersColumn(arr);
        };

        const ElementMenuPosicion = headersColumn.map((value,index)=>( 
            <Grid item style={{width:100}} key={`ElementFixed_${index}`}>
                <TextField 
                    id={`${value.id}_${value.num}`}
                    name={'num'}
                    value={value.num ||''}
                    onChange={handleHeadersPosicion}
                    fullWidth
                    margin='dense'
                    variant='outlined'
                    label={value.label}
                />
            </Grid>
        ));

        const handleClickMenuPosicion = () => { setOpenMenuPosicion(true)};
        
        const handleCloseMenuPosicion = ()=> { setOpenMenuPosicion(false) };

        const handleResetPosicion = ()=>{
            const headersResultStyles = [];
            headersColumn.forEach(value=>{
                headCellsColumn.forEach(value2=>{
                    if(value.id === value2.id){
                        const objeto = {...value};
                        objeto.num = value2.num;
                        headersResultStyles.push(objeto);
                    }
                })
            })
            headersResultStyles.sort(function (a, b) {
                if (a.num > b.num) {
                  return 1;
                }
                if (a.num < b.num) {
                  return -1;
                }
                return 0;
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles));
            setOpenMenuPosicion(false);
            setSavingHeaders(true);
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        };

        const handleProcessPosicion = ()=>{
            const headersResultStyles = headersColumn;
            headersResultStyles.sort(function (a, b) {
                if (a.num > b.num) {
                  return 1;
                }
                if (a.num < b.num) {
                  return -1;
                }
                return 0;
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles))
            setSavingHeaders(true);
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        };

        const handleAddRow = (info)=>{
            if(isNewRow){
                Swal.fire({
                    title:'GUARDA LA FILA NUEVA',
                    toast:true,
                    confirmButtonColor:'#0E3B5F',
                });
            }else if(isEditRow){
                Swal.fire({
                    title:'TERMINE DE EDITAR LA FILA',
                    toast:true,
                    confirmButtonColor:'#0E3B5F',
                });
            }else if(info.isDuplicate){
                const objeto = {...info};
                objeto.id = `rowNew_${variablesObject.label}_${Date.now()}_${uuidv4()}_${Math.floor(Math.random() * 100000)}`;
                objeto._id = `rowNew_${variablesObject.label}_${Date.now()}_${uuidv4()}_${Math.floor(Math.random() * 100000)}`;
                objeto.ColNew = true;
                objeto.isDuplicate = true;
                const arrne = [...backupsRow];
                arrne.unshift(objeto);
                setRows(arrne);
                setBackupsRow(arrne);
                setNewRow(true);
            }else{ 
                const objeto = {};
                objeto.id = `rowNew_${variablesObject.label}_${Date.now()}_${uuidv4()}_${Math.floor(Math.random() * 100000)}`;
                objeto._id = `rowNew_${variablesObject.label}_${Date.now()}_${uuidv4()}_${Math.floor(Math.random() * 100000)}`;
                objeto.ColNew = true;
                objeto.isDuplicate = false;
                const arrne = [...backupsRow];
                arrne.unshift(objeto);
                setRows(arrne);
                setBackupsRow(arrne);
                setNewRow(true);
            }
            
        };

        const handleSaveRowNew = useCallback((idEl, valueEl)=>{
            const datRows = rows.map(elRow=>{
                if(elRow.id.toString() === idEl.toString()){
                    return valueEl
                }else{
                    return elRow
                }
            });
            setEditRow(false);
            setRows(datRows);
            setBackupsRow(datRows);
            setNewRow(false);
        },[rows]);

        const handleDeleteRowNew = useCallback(()=>{
            setNewRow(false);
            const arr = [...rows];
            arr.shift();
            setRows(arr);
            setBackupsRow(arr);
        },[rows]);

        const handleEditRow = useCallback((idEl, valueEl)=>{
            setEditRow(true);
            const datRows = rows.map(elRow=>{
                if(elRow.id.toString() === idEl.toString()){
                    return valueEl
                }else{
                    return elRow
                }
            })
            setRows(datRows);
            setBackupsRow(datRows);
        },[rows]);

        const handleDeleteRow = useCallback((idEl)=>{
            setRows((inf)=>inf.filter(el=>el.id !== idEl));
            setBackupsRow((inf)=>inf.filter(el=>el.id !== idEl));
        },[]);

        const handleDeleteMultiple = ()=>{
            Swal.fire({
                title:`DESEA ELIMINAR TODO(A)S ${variablesObject.title}?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonColor:'#005596'
            }).then((result) => {
                if (result.isConfirmed){
                    const objeto = {};
                    objeto.selectionArr = [...selectionArr];
                    fetch(variablesObject.apiMultiples,{ method:'DELETE', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
                    .then(response=> response.json())
                    .then(result =>{
                        if(result.message){
                            const arrNew = selectionArr.map(el=> el._id);
                            const arrFiltrado_ = rows.filter(el=> !arrNew.includes(el._id));
                            setRows(arrFiltrado_);
                            setBackupsRow(arrFiltrado_);
                            setSelectionArr([]);
                            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
                            setFilterNow(false);
                            setFilterDate(false);
                            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''})
                            enqueueSnackbar(result.message, {variant:'success'});
                        }else{
                            enqueueSnackbar(result.status, {variant:'error'});
                        }
                    })
                }
            })
        };

        const handleSelectionAll = ()=>{
            setSelectionArr(rows);
            setRows([]);
            setContinuoUnSelect(true);
        };

        const handleUnSelect = ()=>{
            setSelectionArr();
            setRows([]);
            setSelectionArr([]);
            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
            setFilterNow(false);
            setFilterDate(false);
            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''});
            setContinuoUnSelect(true);
        };

        const handleSearch = ({target})=>{
            setSearch(target.value);
            if(target.value === ''){
                setRows(backupsRow);
            }else{
                setRows(backupsRow.filter(el=>el[getOptionSearch]?.toLowerCase().includes(target.value.toLowerCase())));
            }
        };

        const handleClickMenuBusqueda = (event) => {
            setOpenMenuBusqueda(event.currentTarget);};

        const handleCloseMenuBusqueda = () => { setOpenMenuBusqueda(null) };

        const handleShowBusqueda = ()=>{
            setShowBusqueda(el=>{
                if(el) setRows(backupsRow);
                return !el
            });
        };

        return(
            <Grid 
                container 
                justifyContent='center'
                style={{width:'100%', padding:0, position:'relative', left:0, minHeight:'90vh' }} 
            >
                <Dialog
                    open={openMenuFilter}
                    onClose={handleCloseMenuFilter}
                    fullWidth
                    maxWidth={'sm'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                    disableEscapeKeyDown
                >
                    <DialogContent>
                        <Grid container justifyContent='center' spacing={1}>
                            { isElementFilterShow ? ElementMenuFilter
                            : <FacebookCircularProgress size={25} style={{marginTop:5}}/>}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent='flex-start' spacing={2} style={{padding:15}}>
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                <Button variant='contained' color="default" fullWidth onClick={handleCloseMenuFilter} endIcon={<ClearIcon/>}>
                                    Cerrar
                                </Button>
                            </Grid>
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                <Button variant='contained' color="secondary" fullWidth onClick={HandleResetFilter} endIcon={<AutorenewIcon/>}>
                                    Resetear
                                </Button>
                            </Grid>
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                <Button variant='contained' color="primary" fullWidth onClick={HandleProcessFilterElement} endIcon={<NavigateNextIcon/>}>
                                    Procesar
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openMenuStyles}
                    onClose={handleCloseMenuStyles}
                    fullWidth
                    maxWidth={'md'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                >
                    <DialogContent>
                        <Grid container spacing={2}>
                            {ElementMenuStyles}
                        </Grid>
                        
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={openMenuPosicion}
                    onClose={handleCloseMenuPosicion}
                    fullWidth
                    maxWidth={'md'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                >
                    <DialogContent>
                        <Grid container spacing={2}>
                            {ElementMenuPosicion}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                    <Grid container justifyContent='flex-start' spacing={2} style={{padding:15}}>
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                <Button variant='contained' color="default" fullWidth onClick={handleCloseMenuPosicion} endIcon={<ClearIcon/>}>
                                    Cerrar
                                </Button>
                            </Grid>
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                <Button variant='contained' color="secondary" fullWidth onClick={handleResetPosicion} endIcon={<AutorenewIcon/>}>
                                    Resetear
                                </Button>
                            </Grid>
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                <Button variant='contained' color="primary" fullWidth onClick={handleProcessPosicion} endIcon={<NavigateNextIcon/>}>
                                    Procesar
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openSelectPersonsMail}
                    onClose={handleCloseSelectPersonsMail}
                    fullWidth
                    maxWidth={'sm'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                    disableEscapeKeyDown
                >
                    <DialogContent>
                        <Autocomplete
                            id="Remitentes"
                            freeSolo
                            options={RemitentesAll}
                            value={Remitentes || ''}
                            onChange={HandleRemitentes}
                            multiple
                            renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  label="Remitentes"
                                />
                              )}
                        /> 
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' onClick={handleCloseSelectPersonsMail} color="default" style={{height:40}}>
                            CANCELAR
                        </Button>
                        <Button variant='contained' onClick={HandleSendCorreos} color="primary" style={{margin:3, height:40}}>
                            ENVIAR
                        </Button>
                    </DialogActions>
                </Dialog>
                <Grid 
                    item 
                    xs={12} 
                    style={{ position:'fixed', top:60, left:0, width:'100%', zIndex:20, minHeight:40 }}
                >
                    <Paper 
                        elevation={2} 
                        square 
                        style={{ 
                            alignItems:'center', 
                            display:'flex', 
                            justifyContent:'center', 
                            padding:5, 
                            width:'100%', 
                        }}
                    >
                        <Grid 
                            alignItems='center'
                            container 
                            justifyContent={ widthWin === 'xs' ||  widthWin === 'sm' ? 'center' : 'flex-start'} 
                            spacing={1} 
                        >
                            {
                                widthWin === 'xs' ||  widthWin === 'sm'?
                                <React.Fragment>
                                    <Grid item  md={3} sm={10} xs={12} style={{ padding:0}}>
                                        {   isShowBusqueda ? 
                                            <Grid 
                                                container 
                                                justifyContent='space-around' 
                                                alignItems='center' 
                                                spacing={0}
                                            >
                                                <Grid item xs={9}>
                                                    <TextField 
                                                        id='SearchOptions'
                                                        fullWidth
                                                        onChange={handleSearch}  
                                                        placeholder={ getOptionSearch || 'Busqueda' }
                                                        size='small'
                                                        value={ getSearch || ''}
                                                        variant='outlined'
                                                        margin='dense'
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='OPCIONES DE BUSQUEDA' placement='top' >
                                                        <span>
                                                        <IconButton 
                                                            color='primary'
                                                            onClick={handleClickMenuBusqueda}  
                                                            aria-controls="menu-column-busqueda" 
                                                            aria-haspopup="true" 
                                                            size='small'
                                                        >                            
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                    <Menu
                                                        id="menu-column-busqueda"
                                                        anchorEl={openMenuBusqueda}
                                                        keepMounted
                                                        open={Boolean(openMenuBusqueda)}
                                                        onClose={handleCloseMenuBusqueda}
                                                    >
                                                        {
                                                            headersColumn.map((el, index)=>
                                                                <MenuItem 
                                                                    key={`${el.id}_${index}_`} 
                                                                    style={{width:'100%'}}
                                                                    onClick={()=>{
                                                                        setOptionSearch(el.id);
                                                                        setOpenMenuBusqueda(null)
                                                                    }}
                                                                >
                                                                    {el.label}
                                                                </MenuItem>
                                                            )
                                                        }
                                                    </Menu>   
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='OCULTAR BUSQUEDA' placement='top'>
                                                        <span>
                                                            <IconButton 
                                                                aria-controls="menu-column-busqueda" 
                                                                aria-haspopup="true" 
                                                                color='primary'
                                                                style={{ background:'dodgerblue', color:'#fff' }}
                                                                onClick={handleShowBusqueda}  
                                                                size='small'
                                                            >                            
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>:
                                            <Grid 
                                                alignItems='center' 
                                                container 
                                                justifyContent='center' 
                                                spacing={2} 
                                                style={{minHeight:68, height:65}}
                                            >
                                                <Grid item>
                                                    <Chip label={variablesObject.title} color='secondary' />
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='MOSTRAR BUSQUEDA' placement='top'>
                                                        <span>
                                                        <IconButton 
                                                            aria-controls="menu-column-busqueda" 
                                                            aria-haspopup="true" 
                                                            color='primary'
                                                            onClick={handleShowBusqueda}  
                                                            size='small'
                                                            style={{ background:'dodgerblue', color:'#fff' }}
                                                        >                            
                                                            <SearchIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        }
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='VER' placement='top'>
                                            <span>
                                            <IconButton size='small' color='primary' onClick={handleClickMenu}  aria-controls="menu-column" aria-haspopup="true" style={{marginRight:2}}>                           
                                                <VisibilityIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>         
                                        <Menu
                                            id="menu-column"
                                            anchorEl={openMenuColumn}
                                            keepMounted
                                            open={Boolean(openMenuColumn)}
                                            onClose={handleCloseMenu}
                                            >
                                            {ElementMenu}
                                        </Menu>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='FIJAR' placement='top' >
                                            <span>
                                            <IconButton size='small' color='primary' onClick={handleClickMenuFixed}  aria-controls="menu-column-fixed" aria-haspopup="true" style={{marginRight:2}}>                     
                                                <ViewWeekIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip> 
                                        <Menu
                                            id="menu-column-fixed"
                                            anchorEl={openMenuColumnFixed}
                                            keepMounted
                                            open={Boolean(openMenuColumnFixed)}
                                            onClose={handleCloseMenuFixed}
                                            >
                                            {ElementMenuFixed}
                                        </Menu>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='FILTRAR' placement='top' >
                                            <span>
                                            <IconButton size='small' color={isFilterNow ? 'secondary' : 'default'} onClick={handleClickMenuFilter} style={{marginRight:2}}>                      
                                                <FilterListIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='FECHAS' placement='top' >
                                            <span>
                                            <IconButton size='small' color={isFilterDate ? 'secondary' : 'default'} onClick={handleClickMenuDate}  aria-controls="menu-column-date" aria-haspopup="true" style={{marginRight:2}}>                            
                                                <DateRangeIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Menu
                                            id="menu-column-date"
                                            anchorEl={openMenuDate}
                                            keepMounted
                                            open={Boolean(openMenuDate)}
                                            onClose={handleCloseMenuDate}
                                        >
                                            <MenuItem key={'ElementMenuDate-Columna'} style={{width:'100%'}}>
                                                <Autocomplete
                                                    id={'AutoComplete-ElementDate'}
                                                    options={headersColumn.filter(el=>el.type==='date')}
                                                    getOptionLabel={option => option.label }
                                                    renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                                    inputValue={elementDate.labelElement || ''}
                                                    onInputChange={HandleAutoComplete}
                                                    size='small'
                                                    style={{width:'100%'}}
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Inicio'}>
                                                <TextField 
                                                    id='Inicio'
                                                    value={elementDate.Inicio || new Date()}
                                                    onChange={HandleMenuDate}
                                                    fullWidth
                                                    margin='dense'
                                                    type='date'
                                                    label='Inicio'
                                                    autoFocus
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Final'}>
                                                <TextField 
                                                    id='Final'
                                                    value={elementDate.Final ||  new Date()}
                                                    onChange={HandleMenuDate}
                                                    fullWidth
                                                    margin='dense'
                                                    type='date'
                                                    label='Final'
                                                    autoFocus
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Process'}>
                                                <Grid container justifyContent='center'>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="default" size='small' onClick={HandleClearDate} >
                                                            <ClearIcon />
                                                        </Fab>
                                                    </Grid>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="secondary" size='small' onClick={HandleResetFilterDate} >
                                                            <AutorenewIcon />
                                                        </Fab>
                                                    </Grid>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="primary" size='small' onClick={HandleProcessFilterDate}>
                                                            <NavigateNextIcon />
                                                        </Fab>
                                                    </Grid>
                                                </Grid>
                                            </MenuItem>
                                        </Menu>   
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='EXPORT PDF' placement='top'>
                                            <span>
                                            <IconButton size='small' aria-controls="menu-cpdf" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuPdf} color='primary'>                          
                                                <PictureAsPdfIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>  
                                        <Menu
                                            id="menu-pdf"
                                            anchorEl={openMenuPdf}
                                            keepMounted
                                            open={Boolean(openMenuPdf)}
                                            onClose={handleCloseMenuPdf}
                                        >
                                            <MenuItem onClick={HandleExportSelectPdf} >
                                                Export Select
                                            </MenuItem>
                                            <MenuItem onClick={HandleExportAllPdf} >
                                                Export All
                                            </MenuItem>
                                            <MenuItem style={{display:'flex', justifyContent:'center'}}>
                                                {
                                                    isReadyPdf ? <PdfElement data={isSelectPdf ? selectionArr : rows} headersColumn={arrHeadersPdf} HandleClickPdf={HandleClickPdf}/>
                                                    : '...'
                                                }
                                            </MenuItem>
                                        </Menu>
                                    </Grid>
                                    <Grid item xs={1}>         
                                        <Tooltip title='EXPORT EXCEL' placement='top'>
                                            <span>
                                            <IconButton size='small' aria-controls="menu-excel" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuExcel} color='primary'>                           
                                                <DescriptionIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Menu
                                            id="menu-excel"
                                            anchorEl={openMenuExcel}
                                            keepMounted
                                            open={Boolean(openMenuExcel)}
                                            onClose={handleCloseMenuExcel}
                                        >
                                            <MenuItem >
                                                {
                                                    selectionArr.length === 0 ? <span onClick={()=>{ setOpenMenuExcel(null);
                                                        Swal.fire({
                                                            title:'NO HAY ELEMENTOS A EXPORTAR',
                                                            toast:true,
                                                            confirmButtonColor:'#0E3B5F',
                                                        });}}>Export Select</span>
                                                    :<ExcelComponent data={selectionArr} titulo={'Export Select'} headersColumn={headersColumn}/>
                                                }
                                            </MenuItem>
                                            <MenuItem >
                                                <ExcelComponent data={rows} titulo={'Export All'} headersColumn={headersColumn} />
                                            </MenuItem>
                                        </Menu>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='CORREOS' placement='top'>
                                            <span>
                                            <IconButton size='small' color='primary' onClick={HandleSelectPersonsMail}  style={{marginRight:2}}>
                                                <MarkunreadMailboxIcon/>
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    {selectionArr.length === 0 ? 
                                        <React.Fragment>
                                            <Grid item xs={1}>
                                                <Tooltip title='ESTILOS' placement='top'>
                                                    <span>
                                                    <IconButton size='small' style={{marginRight:2}} onClick={handleOpenMenuStyles} color='primary'>                           
                                                        <BrushIcon />
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>  
                                            </Grid>
                                            <Grid item xs={1}>
                                                <Tooltip title='POSICION' placement='top'>
                                                    <span>
                                                    <IconButton size='small' style={{marginRight:2}} onClick={handleClickMenuPosicion} color='primary'>
                                                        <BorderVerticalIcon />
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                        </React.Fragment>:null
                                    }
                                    { variablesObject.isButtonAdd ?
                                        <Grid item xs={1}>                      
                                        <Tooltip title='ADD ROW' placement='top'>
                                            <span>
                                            <IconButton  onClick={handleAddRow} color='primary' style={{position:'relative', left:-4}}>
                                                <PlusOneIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>:null}
                                    <Grid item xs={1}>
                                        <Tooltip title='SELECT ALL' placement='top'>
                                            <span>
                                            <IconButton style={{position:'relative',  left:-4}} onClick={handleSelectionAll} color='primary'>
                                                <CheckBoxIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    {
                                        selectionArr.length > 0 &&
                                        <React.Fragment>
                                            <Grid item xs={1}>
                                                <Tooltip title='DELETE ROWS' placement='top'>
                                                    <span>
                                                    <IconButton style={{position:'relative',  left:-4}} onClick={handleDeleteMultiple} color='primary' >
                                                        <DeleteIcon style={{color:'red'}}/>
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <Tooltip title='UNSELECT ROWS' placement='top'>
                                                    <span>
                                                    <IconButton style={{position:'relative',  left:-4}} onClick={handleUnSelect} color='secondary' >
                                                        <CheckBoxOutlineBlankIcon /> 
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                        </React.Fragment>
                                    }
                                </React.Fragment> :
                                <React.Fragment>
                                    <Grid item  lg={3} md={4} sm={10} xs={12}>
                                        {   isShowBusqueda ? 
                                            <Grid container justifyContent='space-between' alignItems='center' spacing={0}>
                                                <Grid item xs={9}>
                                                    <TextField 
                                                        id='SearchOptions'
                                                        fullWidth
                                                        label='Busqueda'
                                                        onChange={handleSearch}  
                                                        placeholder={ getOptionSearch || '' }
                                                        size='small'
                                                        value={ getSearch || ''}
                                                        variant='outlined'
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='OPCIONES DE BUSQUEDA' placement='top' >
                                                        <span>
                                                        <IconButton 
                                                            color='primary' 
                                                            onClick={handleClickMenuBusqueda}  
                                                            aria-controls="menu-column-busqueda" 
                                                            aria-haspopup="true" 
                                                            size='small'
                                                        >                            
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                    <Menu
                                                        id="menu-column-busqueda"
                                                        anchorEl={openMenuBusqueda}
                                                        keepMounted
                                                        open={Boolean(openMenuBusqueda)}
                                                        onClose={handleCloseMenuBusqueda}
                                                    >
                                                        {
                                                            headersColumn.map((el, index)=>
                                                                <MenuItem 
                                                                    key={`${el.id}_${index}_`} 
                                                                    style={{width:'100%'}}
                                                                    onClick={()=>{
                                                                        setOptionSearch(el.id);
                                                                        setOpenMenuBusqueda(null)
                                                                    }}
                                                                >
                                                                    {el.label}
                                                                </MenuItem>
                                                            )
                                                        }
                                                    </Menu>   
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='OCULTAR BUSQUEDA' placement='top'>
                                                        <span>
                                                            <IconButton 
                                                                aria-controls="menu-column-busqueda" 
                                                                aria-haspopup="true" 
                                                                color='primary'
                                                                style={{ background:'dodgerblue', color:'#fff' }}
                                                                onClick={handleShowBusqueda}  
                                                                size='small'
                                                            >                            
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>:
                                            <Grid container justifyContent='center' alignItems='center' >
                                                <Grid item>
                                                    <Chip label={variablesObject.title} color='secondary' />
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='MOSTRAR BUSQUEDA' placement='top'>
                                                        <span>
                                                            <IconButton 
                                                                aria-controls="menu-column-busqueda" 
                                                                aria-haspopup="true" 
                                                                color='primary'
                                                                onClick={handleShowBusqueda}  
                                                                size='small'
                                                            >                            
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        }
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='VER' placement='top'>
                                            <span>
                                            <IconButton color='primary' onClick={handleClickMenu}  aria-controls="menu-column" aria-haspopup="true" style={{marginRight:2}}>                           
                                                <VisibilityIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>         
                                        <Menu
                                            id="menu-column"
                                            anchorEl={openMenuColumn}
                                            keepMounted
                                            open={Boolean(openMenuColumn)}
                                            onClose={handleCloseMenu}
                                            >
                                            {ElementMenu}
                                        </Menu>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='FIJAR' placement='top' >
                                            <span>
                                            <IconButton color='primary' onClick={handleClickMenuFixed}  aria-controls="menu-column-fixed" aria-haspopup="true" style={{marginRight:2}}>                     
                                                <ViewWeekIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip> 
                                        <Menu
                                            id="menu-column-fixed"
                                            anchorEl={openMenuColumnFixed}
                                            keepMounted
                                            open={Boolean(openMenuColumnFixed)}
                                            onClose={handleCloseMenuFixed}
                                            >
                                            {ElementMenuFixed}
                                        </Menu>
                                    </Grid>
                                    <Grid item>
                                        <Tooltip title='FILTRAR' placement='top' >
                                            <span>
                                            <IconButton color={isFilterNow ? 'secondary' : 'default'} onClick={handleClickMenuFilter} style={{marginRight:2}}>                      
                                                <FilterListIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item>
                                        <Tooltip title='FECHAS' placement='top' >
                                            <span>
                                            <IconButton color={isFilterDate ? 'secondary' : 'default'} onClick={handleClickMenuDate}  aria-controls="menu-column-date" aria-haspopup="true" style={{marginRight:2}}>                            
                                                <DateRangeIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Menu
                                            id="menu-column-date"
                                            anchorEl={openMenuDate}
                                            keepMounted
                                            open={Boolean(openMenuDate)}
                                            onClose={handleCloseMenuDate}
                                        >
                                            <MenuItem key={'ElementMenuDate-Columna'} style={{width:'100%'}}>
                                                <Autocomplete
                                                    id={'AutoComplete-ElementDate'}
                                                    options={headersColumn.filter(el=>el.type==='date')}
                                                    getOptionLabel={option => option.label }
                                                    renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                                    inputValue={elementDate.labelElement || ''}
                                                    onInputChange={HandleAutoComplete}
                                                    size='small'
                                                    style={{width:'100%'}}
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Inicio'}>
                                                <TextField 
                                                    id='Inicio'
                                                    value={elementDate.Inicio || new Date()}
                                                    onChange={HandleMenuDate}
                                                    fullWidth
                                                    margin='dense'
                                                    type='date'
                                                    label='Inicio'
                                                    autoFocus
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Final'}>
                                                <TextField 
                                                    id='Final'
                                                    value={elementDate.Final ||  new Date()}
                                                    onChange={HandleMenuDate}
                                                    fullWidth
                                                    margin='dense'
                                                    type='date'
                                                    label='Final'
                                                    autoFocus
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Process'}>
                                                <Grid container justifyContent='center'>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="default" size='small' onClick={HandleClearDate} >
                                                            <ClearIcon />
                                                        </Fab>
                                                    </Grid>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="secondary" size='small' onClick={HandleResetFilterDate} >
                                                            <AutorenewIcon />
                                                        </Fab>
                                                    </Grid>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="primary" size='small' onClick={HandleProcessFilterDate}>
                                                            <NavigateNextIcon />
                                                        </Fab>
                                                    </Grid>
                                                </Grid>
                                            </MenuItem>
                                        </Menu>   
                                    </Grid>
                                    <Grid item>
                                        <Tooltip title='EXPORT PDF' placement='top'>
                                            <span>
                                            <IconButton aria-controls="menu-cpdf" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuPdf} color='primary'>                          
                                                <PictureAsPdfIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>  
                                        <Menu
                                            id="menu-pdf"
                                            anchorEl={openMenuPdf}
                                            keepMounted
                                            open={Boolean(openMenuPdf)}
                                            onClose={handleCloseMenuPdf}
                                        >
                                            <MenuItem onClick={HandleExportSelectPdf} >
                                                Export Select
                                            </MenuItem>
                                            <MenuItem onClick={HandleExportAllPdf} >
                                                Export All
                                            </MenuItem>
                                            <MenuItem style={{display:'flex', justifyContent:'center'}}>
                                                {
                                                    isReadyPdf ? <PdfElement data={isSelectPdf ? selectionArr : rows} headersColumn={arrHeadersPdf} HandleClickPdf={HandleClickPdf}/>
                                                    : '...'
                                                }
                                            </MenuItem>
                                        </Menu>
                                    </Grid>
                                    <Grid item>         
                                        <Tooltip title='EXPORT EXCEL' placement='top'>
                                            <span>
                                            <IconButton aria-controls="menu-excel" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuExcel} color='primary'>                           
                                                <DescriptionIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Menu
                                            id="menu-excel"
                                            anchorEl={openMenuExcel}
                                            keepMounted
                                            open={Boolean(openMenuExcel)}
                                            onClose={handleCloseMenuExcel}
                                        >
                                            <MenuItem >
                                                {
                                                    selectionArr.length === 0 ? <span onClick={()=>{ setOpenMenuExcel(null);
                                                        Swal.fire({
                                                            title:'NO HAY ELEMENTOS A EXPORTAR',
                                                            toast:true,
                                                            confirmButtonColor:'#0E3B5F',
                                                        });}}>Export Select</span>
                                                    :<ExcelComponent data={selectionArr} titulo={'Export Select'} headersColumn={headersColumn}/>
                                                }
                                            </MenuItem>
                                            <MenuItem >
                                                <ExcelComponent data={rows} titulo={'Export All'} headersColumn={headersColumn} />
                                            </MenuItem>
                                        </Menu>
                                    </Grid>
                                    <Grid item>
                                        <Tooltip title='CORREOS' placement='top'>
                                            <span>
                                            <IconButton color='primary' onClick={HandleSelectPersonsMail}  style={{marginRight:2}}>
                                                <MarkunreadMailboxIcon/>
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item>
                                        <Tooltip title='ESTILOS' placement='top'>
                                            <span>
                                            <IconButton style={{marginRight:2}} onClick={handleOpenMenuStyles} color='primary'>                           
                                                <BrushIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>  
                                    </Grid>
                                    <Grid item>
                                        <Tooltip title='POSICION' placement='top'>
                                            <span>
                                            <IconButton style={{marginRight:2}} onClick={handleClickMenuPosicion} color='primary'>
                                                <BorderVerticalIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item>
                                        <Tooltip title='ADD ROW' placement='top'>
                                            <span>
                                            <IconButton style={{marginRight:2}} onClick={handleAddRow} color='primary'>
                                                <PlusOneIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='SELECT ALL' placement='top'>
                                            <span>
                                            <IconButton style={{marginRight:2}} onClick={handleSelectionAll} color='primary'>
                                                <CheckBoxIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    {
                                        selectionArr.length > 0 &&
                                        <React.Fragment>
                                            <Grid item >
                                                <Tooltip title='DELETE ROWS' placement='top'>
                                                    <span>
                                                    <IconButton style={{marginRight:2}} onClick={handleDeleteMultiple} color='primary' >
                                                        <DeleteIcon style={{color:'red'}}/>
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                            <Grid item >
                                                <Tooltip title='UNSELECT ROWS' placement='top'>
                                                    <span>
                                                    <IconButton style={{marginRight:2}} onClick={handleUnSelect} color='secondary' >
                                                        <CheckBoxOutlineBlankIcon /> 
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                        </React.Fragment>
                                    }
                                </React.Fragment> 
                            }
                        </Grid>
                    </Paper>
                </Grid>
                <Grid 
                    item 
                    xs={12} 
                    style={{marginTop:widthWin === 'xs' ? 109.5 : 59}}
                >
                    <Paper 
                        square 
                        style={{
                            minHeight:widthWin === 'xl' ? '85vh' : widthWin === 'lg' ? '82vh' : '74vh',  
                            maxHeight:widthWin === 'xl' ? '85vh' : widthWin === 'lg' ? '82vh' : '74vh', 
                            width:widthWin === 'xs' ? '100%' : widthWin === 'sm' ? '100%' : variablesObject.sumWidth,
                        }}
                    >
                        { isSavingHeaders ? 
                        <Grid container>
                            <Grid item xs={12} style={{height:'100%', display:'flex', justifyContent:'center', marginTop:'33vh'}}  >                                                                                                                                                                                                                  
                                <FacebookCircularProgress size={40} style={{alignSelf:'center'}}/>
                            </Grid>
                        </Grid>
                        :
                        <React.Fragment>
                        {isCharging && <LinearProgress color='secondary' />}
                        <TableContainerYounet 
                            maxHeight={widthWin === 'xl' ? '80vh' : widthWin === 'lg' ? '77vh' : '63vh'} 
                            minHeight={widthWin === 'xl' ? '80vh' : widthWin === 'lg' ? '77vh' : '63vh'}
                            width={widthWin === 'xl' ? `${variablesObject.sumWidth}px` : widthWin === 'lg' ? `${variablesObject.sumWidth}px` : '100%'}
                        >
                            <TableYounet>
                                <EnhancedTableHead
                                    classes={classes}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={rows.length}
                                    headCells={headersColumn}
                                    variablesObject={variablesObject}
                                />               
                                <TableBody>
                                    {stableSort(rows, getComparator(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, index) => {
                                            return (
                                            <React.Fragment key={row._id}>
                                                {
                                                    row.ColNew ?
                                                    <RowNew
                                                        arrInfoSelect={arrInfoSelect}
                                                        Empresa={authTokens.Empresa}
                                                        handleSaveRowNew={handleSaveRowNew}
                                                        handleDeleteRowNew={handleDeleteRowNew}
                                                        headCells={headersColumn} 
                                                        index={index}
                                                        row={row}
                                                        variablesObject={variablesObject}
                                                        marcas={marcas}
                                                        tipos={tipos}
                                                    />: row.EditRowNow ?
                                                    <RowEdit
                                                        arrInfoSelect={arrInfoSelect}
                                                        Empresa={authTokens.Empresa}
                                                        getArrMac={getArrMac}
                                                        handleSaveRowNew={handleSaveRowNew}
                                                        headCells={headersColumn} 
                                                        index={index}
                                                        row={row}
                                                        variablesObject={variablesObject}
                                                        marcas={marcas}
                                                        tipos={tipos}
                                                    />:
                                                    <Roow               
                                                        Empresa={authTokens.Empresa} 
                                                        enqueueSnackbar={enqueueSnackbar}                       
                                                        getArrMac={getArrMac}
                                                        handleAddRow={handleAddRow}
                                                        handleClickRow={handleClickRow}
                                                        handleEditRow={handleEditRow}
                                                        handleDeleteRow={handleDeleteRow}
                                                        headCells={headersColumn} 
                                                        index={index} 
                                                        key={row._id} 
                                                        row={row} 
                                                        selectionArr={selectionArr}
                                                        variablesObject={variablesObject}
                                                        marcas={marcas}
                                                        tipos={tipos}
                                                    />
                                                }
                                            </React.Fragment>
                                            );
                                        })}
                                </TableBody>
                            </TableYounet>
                        </TableContainerYounet>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15, 20, 25]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage='Filas'
                            style={{
                                alignItems:'center',
                                display:'flex', 
                                flexWrap:'no-wrap',
                                height:40, border:'1px solid gainsboro',
                                justifyContent:widthWin === 'xs' ? 'flex-start' : widthWin === 'sm' ? 'flex-start' : 'flex-end' , 
                                minHeight:40,
                                marginTop:4,
                                overflowY:'hidden',
                                paddingRight:widthWin === 'md' ? 75 : 0,
                                width:widthWin === 'xs' ? '100%' : widthWin === 'sm' ? '100%' : variablesObject.sumWidth,
                            }}
                        />
                        </React.Fragment>
                        }
                    </Paper>
                </Grid>
            </Grid>  
        )
    };

    function Elementos(props) {
        const objeto = {...props};
        objeto.widthWin = props.width;
        return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom',horizontal: 'center'}}>
            <Elemento info={objeto}/>
        </SnackbarProvider>
    );
    };

    export default withWidth()(Elementos);